let stropheConnection = require('./stropheConnection.js');
let storage = require('./storage.js');
let CryptLib = require('cryptlib');
let anchorme = require("anchorme").default;
let timeFormat = require('./timeformat.js');
let iv = 'ddc0f15cc2c90fca';
const PNF = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
let language = require('./locale/language.js');
let resourceIpUpdate = require('./resourceIpUpdate.js');
const indexDb = require('./indexDb.js');
let userSession = require('./session.js');
const Push = require('push.js');
let broadcastProfile = require('./broadcastProfile.js')
const webEncrypt  = require('./webchatEncryptDecrypt.js');

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
module.exports = {

    toJID: function () {
        if (webEncrypt.getFromLocalStorageAndDecrypt('toJID')) {
            return webEncrypt.getFromLocalStorageAndDecrypt('toJID');
        } else {
            return "";
        }
    },
    getTimestamp: function () {
        let timeStampInMs = window.performance && window?.performance.now && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation').length > 0 ? window.performance.now() + window.performance.getEntriesByType('navigation')[0].startTime : Date.now();

        return (timeStampInMs, Date.now());
    },
    closeProfilePopUp: function (popupId) {
        document.getElementById(popupId).style.visibility = 'hidden';
        document.getElementById(popupId).style.opacity = '0';
    },
    getId: function () {
        let randomValue = module.exports.cryptoRandomGenerate();

        return 'id' + randomValue.toString(36).replace(/[^a-z]+/g, '').substring(0, 9);
    },
    randomString: function (length, chars) {
        let mask = '';
        if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
        if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        if (chars.indexOf('#') > -1) mask += 'ABCDEFGHIJKLMNopqrstuvwxyz';
        if (chars.indexOf('!') > -1) mask += 'abcdefghijklmnOPQRSTUVWXYZ';
        let result = '';
        let id = "";
        let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
        if (loginUserInfo != null) {
            id = loginUserInfo[0][0];
        }
        
        for (let i = length; i > 0; --i){
            let randomValue = module.exports.cryptoRandomGenerate();
            result += mask[Math.round(randomValue * (mask.length - 1))];
        } 
        return 'id' + id + result;
    },
    edituserprofilename: function () {
        $(".nameEdit").click(function () {
            $('.profile-name').css('display', 'none');
            $('.nameEdit').css('display', 'none');
            $('.pchar-counter').css('display', 'block');
            $('.get-my-name').css('display', 'flex');
            let text_length = $('#profilename').val().length;
            let text_max = 30;
            let text_remaining = text_max - text_length;
            let limitValue;
            $('.pchar-counter').html(text_remaining);

            $("#profilename").on('input', function () {


                text_length = $('#profilename').val().length;
                text_remaining = text_max - text_length;
                $('.pchar-counter').html(text_remaining);

                if (text_length <= 30) {
                    text_remaining = text_max - text_length;
                    $('.pchar-counter').html(text_remaining);
                } else {
                    limitValue = $('#profilename').val().substring(0, 30);
                    $('#profilename').val(limitValue);
                }
            });

        });
    },
    ObjectLength: function (object) {
        let length = 0;
        for (let key in object) {
            if (object.hasOwnProperty(key)) {
                ++length;
            }
        }
        return length;
    },
    toTitleCase: function (str) {
        return str.replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    },
    scrollbottom: function (id) {
        let height = 0;
        $(id).find('.row').each(function (i, value) {
            height += parseInt($(this).height());
        });
        height += '';
        $(id).scrollTop(height);

    },
    mediaDesignImage: function (background,imgmsgid) {
        let img = new Image();
        let width;
        let height;
        img.addEventListener("load", function () {
            width = this.naturalWidth;
            height = this.naturalHeight;
            if (width > height && width > 330) {
                $('#image-' + imgmsgid).width(330);
                $('#image-' + imgmsgid).height(186);
                if ($("#chat-" + imgmsgid).find('.sender')) {
                    $("#chat-" + imgmsgid).find('.sender').width(330);
                }
                else if ($("#chat-" + imgmsgid).find('.receiver')) {
                    $("#chat-" + imgmsgid).find('.receiver').width(330);
                }
            }
            else if (height > width && height > 330) {
                $('#image-' + imgmsgid).width(330);
                $('#image-' + imgmsgid).height(330);
                if ($("#chat-" + imgmsgid).find('.sender')) {
                    $("#chat-" + imgmsgid).find('.sender').width(330);
                }
                else if ($("#chat-" + imgmsgid).find('.receiver')) {
                    $("#chat-" + imgmsgid).find('.receiver').width(330);
                }
            } else {
                $('#image-' + imgmsgid).width(330);
                $('#image-' + imgmsgid).height(330);
            }
        });
        img.src = background;
    },
    mediaDesignVideo: function(vidbackground,imgmsgid){
        let vidimg = new Image();
        let width;
        let height;
        vidimg.addEventListener("load", function () {
            width = this.naturalWidth;
            height = this.naturalHeight;
            if (width > height && width > 220) {
                $('#video-' + imgmsgid).width(220);
                $('#video-' + imgmsgid).height(160);
                if ($("#chat-" + imgmsgid).find('.sender')) {
                    $("#chat-" + imgmsgid).find('.sender').width(220);
                }
                else if ($("#chat-" + imgmsgid).find('.receiver')) {
                    $("#chat-" + imgmsgid).find('.receiver').width(220);
                }
            }
            else if (height > width && height > 220) {
                $('#video-' + imgmsgid).width(160);
                $('#video-' + imgmsgid).height(220);
                if ($("#chat-" + imgmsgid).find('.sender')) {
                    $("#chat-" + imgmsgid).find('.sender').width(160);
                }
                else if ($("#chat-" + imgmsgid).find('.receiver')) {
                    $("#chat-" + imgmsgid).find('.receiver').width(160);
                }
            } else {
                $('#video-' + imgmsgid).width(220);
                $('#video-' + imgmsgid).height(160);
            }
        });
        vidimg.src = vidbackground;
    },
    mediadesign: function (message_type, imgmsgid) {
        if (message_type == "image") {
            let background = $('#image-' + imgmsgid).find('p').attr('src');
            module.exports.mediaDesignImage(background,imgmsgid)

        } else if (message_type == "video") {
            let vidbackground = $('#video-' + imgmsgid).find('.thumbnail-img').attr('src');
            module.exports.mediaDesignVideo(vidbackground,imgmsgid)
        }
    },
    forwardmsg: function () {

        $('.select-message').change(function () {
            let selectedmsgInfo = {};
            let index = 0;
            $('input:checkbox.select-message').each(function () {
                let id = (this.checked ? $(this).val() : "");
                if (id != '') {
                    let arr = id.split('-');
                    let result = arr.splice(0, 2);
                    result.push(arr.join('-'));
                    selectedmsgInfo[index] = {};
                    selectedmsgInfo[index].keyid = result[0];
                    selectedmsgInfo[index].type = result[1];
                    selectedmsgInfo[index].message = result[2];
                    webEncrypt.encryptAndStoreInLocalStorage('selectedmsgInfo', selectedmsgInfo);
                    index++;
                }
            });
            if (index == 0) {
                webEncrypt.deleteItemFromLocalStorage('selectedmsgInfo');
            }
            let content = index + " selected";
            $(".multi-count").html(content);

            let is_priority_ack = true;
            let selectedCheckboxEl = $('#conversation .message-body input:checked');
            selectedCheckboxEl.each(function () {
            if($(this).parent().parent().find('.acknowledge').length >0 || $(this).parent().parent().find('.acknow-accept').length > 0){
                is_priority_ack = false;
            }
            })
            if(is_priority_ack){
                $(".iconTrash").show();
            }else {
                $(".iconTrash").hide();
            }

        });
        $('.forward-tab').on("click", function (event) {
            if ($(this).find('.active').text() == "Contacts") {
                $('.fwdrosters .filter').show();
            } else {
                $('.fwdrosters .filter').hide();
                $('.fwdrosters .filter-options').hide();
            }
        });
        $(".forwardsingle").off("click");
        $(".forwardsingle").click(function (e) {
            $(".recent-fwd").addClass("active");
            $(".contact-fwd").removeClass("active");
            $('#contact').hide()
            $('#recent-contact').show()
            if ($('.fwdrosters').find('.tab .active').text() == "Contacts") {
                $('.fwdrosters .filter').show();
            } else {
                $('.fwdrosters .filter').hide();
            }
            $("input:checkbox.select-message3").prop("checked", false);
            $(this).attr('disabled', false);
            let selectedmsgInfo = {};
            $("#forwardText").val('');  
            $(".fwd-filter").find('.active').removeClass('active');
            $(".fwd-filter").find('.site').addClass('active');
            $('.fwd-filter').removeClass("menu");
            $("#forward-msg").find('.recentchatcontact').children().show();
            $("#forward-msg").find('.rosterchatcontact').children().show();
            let id = $(this).closest('.message-body').find('input:checkbox').attr('value');
            let arr,result,msgId,msgType,msgs;
            if (typeof id == "undefined") {
                id = $(this).attr("id");
                arr = id.split('-');
                result = arr.splice(0, 2);
                result.push(arr.join('-'));
                msgId = result[0];
                msgType = result[1];
                msgs = result[2];
            } else {
                arr = id.split('-');
                result = arr.splice(0, 2);
                result.push(arr.join('-'));
                msgId = result[0];
                msgType = result[1];
                msgs = result[2];
            }
            if (id != '') {

                selectedmsgInfo[0] = {};

                selectedmsgInfo[0].message = msgs;
                selectedmsgInfo[0].keyid = msgId;
                selectedmsgInfo[0].type = msgType;

                webEncrypt.encryptAndStoreInLocalStorage('selectedmsgInfo', selectedmsgInfo);

            }
            $("#forward-msg").addClass("open");
            $("#forward-msg .frwrd-msg-send").show();

            let recentforward = require('./recentforward.js');
            let page = 1;
            let search = $("#forwardText").val();

            let recentFwdQueryParam = '?page=' + page + '&size=' + language.locali().default_recent_chat_pagination + '&search=' + search+ '&forForwarding=' + true;

            recentforward.getRecentFwdContacts(recentFwdQueryParam,page)
        });

        $("body").on('click', '.deletesingle', function (event) {   
            let selectedmsgInfo = {};
            $(".replyclose").trigger('click');
            $(".exit_and_del").hide();
            let id = $(this).closest('.message-body').find('input:checkbox').attr('value');
            if (id != '') {
               let result = id.split('-');
                selectedmsgInfo[0] = {};
                selectedmsgInfo[0].keyid = result[0];
                selectedmsgInfo[0].type = result[1];
                selectedmsgInfo[0].message = result[2];
                webEncrypt.encryptAndStoreInLocalStorage('selectedmsgInfo', selectedmsgInfo);

            }

            if (typeof $(this).data('msgtime') != 'undefined') {
                let dateString = $(this).data('msgtime');
                let now = new Date();
                let currentUtc = new Date(now.toUTCString().slice(0, -4));
                let d = new Date(dateString.replace(/-/g, "/"));

                let differenceTravel = currentUtc.getTime() - d.getTime();
                let datediff = Math.floor((differenceTravel) / (1000));

                let settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
                let RecallTime = settings.recallTime;

                let content,broadcastProfile,tojid;
                if (datediff >= 0 && datediff < parseInt(RecallTime * 60)) {
                    content = '<div id = "' + id + '">Are you sure want to Delete?</div> ';
                    $("#exit-group").find('.save').html(language.locali().delete);
                    $("#exit-group").find('.popup-mute').html(content);
                    $("#exit-group").addClass("open");
                    broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');
                    
                    tojid = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());

                    if (broadcastProfile != null && typeof broadcastProfile[tojid] != "undefined" && broadcastProfile[tojid][0] == 'broadcast') {
                        $("#deleteforeveryone").hide();
                    }
                    else {
                        $("#deleteforeveryone").show();
                    }
                } else {

                    $("#deleteforeveryone").hide();
                    content = '<div id = "' + id + '">Are you sure want to Delete?</div> ';
                    $("#exit-group").find('.save').html(language.locali().delete);
                    $("#exit-group").find('.popup-mute').html(content);
                    $("#exit-group").addClass("open");
                }
            }
            else {
                $("#deleteforeveryone").hide();
                let content = '<div id = "' + id + '">Are you sure want to Delete?</div> ';
                $("#exit-group").find('.save').html(language.locali().delete);
                $("#exit-group").find('.popup-mute').html(content);
                $("#exit-group").addClass("open");
            }
        });

        $('.ackClick').off('click');
        $("#acknowledge-msg .mute-bts #save-ack").off('click');
        $("#acknowledge-msg .mute-bts #cancel-ack").off('click');
        $("#acknowledge-msg .mute-bts #cancel-ack").click(function () {
            $("#acknowledge-msg").removeClass("open");
        });
        $('.ackClick').click(function () {
            let toJID = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());
            if(module.exports.checkBlockedOrNotInGroup(toJID)) {
                let message = $(this).closest('.message-body').attr('id');
                let toId = $(this).attr('id');
                $("#acknowledge-msg").addClass("open");
                $("#acknowledge-msg").find('input[name="ack-message-id"]').val(message);
                $("#acknowledge-msg").find('input[name="ack-to-id"]').val(toId);
            }
        });
        $("#acknowledge-msg .mute-bts #save-ack").click(function () {
            let randomValue = module.exports.cryptoRandomGenerate();

            let messageid = randomValue.toString(36).replace(/[^a-z]+/g, '').substring(0, 9);
            let message = $("#acknowledge-msg").find('input[name="ack-message-id"]').val();
            let msgid = message.split('-')[1];
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());

            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');

            let broadcastId = $('#chat-' + msgid).attr('data-broadcastmsgid');

            if($('#chat-' + msgid).find('.priority-message').text() == language.locali().priority_message) {
                module.exports.priorityMessageAcknowledged(nodeJid, msgid);
            }


            if (userInfo != null && typeof userInfo[nodeJid] != "undefined") {
                let userJID = stropheConnection.logininfo.userJID;
                let ackiq = stropheConnection.StropheJs().$msg({
                    to: nodeJid + "@" + stropheConnection.Server(),
                    from: userJID + "@" + stropheConnection.Server(),
                    id: messageid,
                    type: "chat"
                }).c('acknowledged', {
                    xmlns: 'urn:xmpp:receipts',
                    id: msgid,
                    ack_status: 1,
                    broadcast_msgid:broadcastId
                });
                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(ackiq);
                }
                $('#chat-' + msgid).find('.ackClick').removeClass("ackClick").addClass("acknowledged");
                $('#chat-' + msgid).find('.acknowledged').removeClass("acknowledge");

                $('#chat-' + msgid).find('.acknowledged').html('Acknowledged <i class="acknow"></i>');
                $('#'+msgid).parent().parent().find('.msg-sent-status').find('.ackStatus').text('Acknowledged')
            } else if (groupInfo != null && typeof groupInfo[nodeJid] != "undefined") {
                let msgPriority = $('#chat-' + msgid).attr("data-priority")
                let message_ack = $('#chat-' + msgid).attr("data-ack")
                let userJID = stropheConnection.logininfo.userJID;
                let ackiq =stropheConnection
                        .StropheJs()
                        .$iq({
                            type: "set",
                            id: messageid
                        })
                        .c("query", {
                            xmlns: "jabber:iq:user_activities",
                            status: "send_ack_status",
                            message_from: userJID + "@" + stropheConnection.Server(),
                            message_to: nodeJid  + "@" + stropheConnection.Server(),
                            message_id: msgid,
                            message_priority: msgPriority,
                            message_ack: message_ack,
                            ack_status:"1",
                            to_user:nodeJid,
                            group_id:nodeJid  + "@" + stropheConnection.Server()
                        });

                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(ackiq);
                }
                $('#chat-' + msgid).find('.ackClick').removeClass("ackClick").addClass("acknowledged");
                $('#chat-' + msgid).find('.acknowledged').removeClass("acknowledge");

                $('#chat-' + msgid).find('.acknowledged').html('Acknowledged <i class="acknow"></i>');
            }
            $("#acknowledge-msg").removeClass("open");
            $('#chat-' + msgid).find('.acknowledged').off('click');
        });

        $('.acknow-accept').off('click');
        $("#accept-msg .mute-bts #save-acc").off('click');
        $("#accept-msg .mute-bts #cancel-acc").off('click');
        $("#accept-msg .mute-bts #cancel-acc").click(function () {
            $("#accept-msg").removeClass("open");
        });
        $('.acknow-accept').click(function () {
            let toJID = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());
            if(module.exports.checkBlockedOrNotInGroup(toJID)) {
                let message = $(this).closest('.message-body').attr('id');
                let toId = $(this).attr('id');
                $("#accept-msg").addClass("open");
                $("#accept-msg").find('input[name="acc-message-id"]').val(message);
                $("#accept-msg").find('input[name="acc-to-id"]').val(toId);
            }
        });
        $("#accept-msg .mute-bts #save-acc").click(function () {
            let randomValue = module.exports.cryptoRandomGenerate();

            let messageid = randomValue.toString(36).replace(/[^a-z]+/g, '').substring(0, 9);
            let message = $("#accept-msg").find('input[name="acc-message-id"]').val();
            let msgid = message.split('-')[1];
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());

            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
            let broadcastId = $('#chat-' + msgid).attr('data-broadcastmsgid');

            if($('#chat-' + msgid).find('.priority-message').text() == language.locali().priority_message) {
                module.exports.priorityMessageAcknowledged(nodeJid, msgid);
            } 

            if (userInfo != null && typeof userInfo[nodeJid] != "undefined") {

                let userJID = stropheConnection.logininfo.userJID;
                let ackiq = stropheConnection.StropheJs().$msg({
                    to: nodeJid + "@" + stropheConnection.Server(),
                    from: userJID + "@" + stropheConnection.Server(),
                    id: messageid,
                    type: "chat"
                }).c('acknowledged', {
                    xmlns: 'urn:xmpp:receipts',
                    id: msgid,
                    ack_status: 1,
                    broadcast_msgid:broadcastId
                });
                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(ackiq);
                }
                $('#chat-' + msgid).find('.acknow-accept').removeClass("acknow-accept").addClass("accepted");
                $('#chat-' + msgid).find('.acknow-reject').remove();
                $('#chat-' + msgid).find('.accepted').html('Accepted <i><img src="./src/images/Accept_ic.svg" alt="accept"/></i>');
                $('#'+msgid).parent().parent().find('.msg-sent-status').find('.ackStatus').text('Accepted')


            } else if (groupInfo != null && typeof groupInfo[nodeJid] != "undefined") {

                let msgPriority = $('#chat-' + msgid).attr("data-priority")
                let message_ack = $('#chat-' + msgid).attr("data-ack")
                let userJID = stropheConnection.logininfo.userJID;
                let ackiq =stropheConnection
                    .StropheJs()
                    .$iq({
                        type: "set",
                        id: messageid
                    })
                    .c("query", {
                        xmlns: "jabber:iq:user_activities",
                        status: "send_ack_status",
                        message_from: userJID + "@" + stropheConnection.Server(),
                        message_to: nodeJid  + "@" + stropheConnection.Server(),
                        message_id: msgid,
                        message_priority: msgPriority,
                        message_ack: message_ack,
                        ack_status:"1",
                        to_user:nodeJid,
                        group_id:nodeJid  + "@" + stropheConnection.Server()
                    });
            
                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(ackiq);
                }
                $('#chat-' + msgid).find('.acknow-accept').removeClass("acknow-accept").addClass("accepted");
                $('#chat-' + msgid).find('.acknow-reject').remove();
                $('#chat-' + msgid).find('.accepted').html('Accepted <i><img src="./src/images/Accept_ic.svg" alt="accept"/></i>');
            }
            $("#accept-msg").removeClass("open");
            $('#chat-' + msgid).find('.accepted').off('click');
        });

        $('.acknow-reject').off('click');
        $("#reject-msg .mute-bts #save-rej").off('click');
        $("#reject-msg .mute-bts #cancel-rej").off('click');
        $("#reject-msg .mute-bts #cancel-rej").click(function () {
            $("#reject-msg").removeClass("open");
        });
        $('.acknow-reject').click(function () {
            let toJID = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());
            if(module.exports.checkBlockedOrNotInGroup(toJID)) {
                let message = $(this).closest('.message-body').attr('id');
                let toId = $(this).attr('id');
                $("#reject-msg").addClass("open");
                $("#reject-msg").find('input[name="rej-message-id"]').val(message);
                $("#reject-msg").find('input[name="rej-to-id"]').val(toId);
            }
        });
        $("#reject-msg .mute-bts .save").click(function () {
            let randomValue = module.exports.cryptoRandomGenerate();
            let messageid = randomValue.toString(36).replace(/[^a-z]+/g, '').substring(0, 9);
            let message = $("#reject-msg").find('input[name="rej-message-id"]').val();
            let msgid = message.split('-')[1];
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());

            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
            let broadcastId = $('#chat-' + msgid).attr('data-broadcastmsgid');

            if($('#chat-' + msgid).find('.priority-message').text() == language.locali().priority_message) {
                module.exports.priorityMessageAcknowledged(nodeJid, msgid);
            }

           if (userInfo != null && typeof userInfo[nodeJid] != "undefined") {
                let userJID = stropheConnection.logininfo.userJID;
                let ackiq = stropheConnection.StropheJs().$msg({
                    to: nodeJid + "@" + stropheConnection.Server(),
                    from: userJID + "@" + stropheConnection.Server(),
                    id: messageid,
                    type: "chat"
                }).c('acknowledged', {
                    xmlns: 'urn:xmpp:receipts',
                    id: msgid,
                    ack_status: 2,
                    broadcast_msgid:broadcastId

                });
                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(ackiq);
                }
                $('#chat-' + msgid).find('.acknow-reject').removeClass("acknow-reject").addClass("rejected");
                $('#chat-' + msgid).find('.acknow-accept').remove();
                $('#chat-' + msgid).find('.rejected').html('Rejected <i><img src="./src/images/Reject_ic.svg" alt="accept"/></i>');
                $('#'+msgid).parent().parent().find('.msg-sent-status').find('.ackStatus').text('Rejected')


            } else if (groupInfo != null && typeof groupInfo[nodeJid] != "undefined") {

                let msgPriority = $('#chat-' + msgid).attr("data-priority")
                let message_ack = $('#chat-' + msgid).attr("data-ack")
                let userJID = stropheConnection.logininfo.userJID;
                let ackiq =stropheConnection
                    .StropheJs()
                    .$iq({
                        type: "set",
                        id: messageid
                    })
                    .c("query", {
                        xmlns: "jabber:iq:user_activities",
                        status: "send_ack_status",
                        message_from: userJID + "@" + stropheConnection.Server(),
                        message_to: nodeJid  + "@" + stropheConnection.Server(),
                        message_id: msgid,
                        message_priority: msgPriority,
                        message_ack: message_ack,
                        ack_status:"2",
                        to_user:nodeJid,
                        group_id:nodeJid  + "@" + stropheConnection.Server()
                    });
                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(ackiq);
                }
               
                $('#chat-' + msgid).find('.acknow-reject').removeClass("acknow-reject").addClass("rejected");
                $('#chat-' + msgid).find('.acknow-accept').remove();
                $('#chat-' + msgid).find('.rejected').html('Rejected <i><img src="./src/images/Reject_ic.svg" alt="accept"/></i>');
            }
            $("#reject-msg").removeClass("open");
            $('#chat-' + msgid).find('.rejected').off('click');
        });
        /** PDF file Download function **/
        $(".ikonixFileDownload").off("click");
        $(".ikonixFileDownload").click(function (e) {
            let id = $(this).attr('id');
            let fileName = $(this).attr('title');
            let userToken = storage.getuserToken();
            let mediaUrl = window._env_.ApiURL + "/media/";

            let url = mediaUrl + id + "?mf=" + userToken;
            module.exports.FileDownload(url,fileName);
        });

        function replymsgInfoIQSend(tojid,broadcastProfile,groupInfo,userInfo,result,replymsgInfo){
            let chatType;
            if (broadcastProfile != null && typeof broadcastProfile[tojid] != "undefined" && broadcastProfile[tojid][0] == 
            'broadcast') {
                chatType = 'chat';
            } else if (groupInfo != null && typeof groupInfo[tojid] != "undefined") {
                chatType = 'normal';
            } else if (userInfo != null && typeof userInfo[tojid] != "undefined") {
                chatType = 'chat';
            }
            let getReplymessage = stropheConnection
                .StropheJs()
                .$iq({
                    type: "get",
                    id: module.exports.getId(),
                    to: stropheConnection.Server()
                })
                .c("query", {
                    xmlns: "jabber:iq:user_activities",
                    status: "reply_message",
                    chat_type: chatType,
                    message_id: result[0],
                    reply_id: result[0]
                });
            if (stropheConnection.Connection().connected) {
                let ReplyMsgContent = '';
                let ReplyMsgId = "";
                
                webEncrypt.encryptAndStoreInLocalStorage('ReplyMsgContent', ReplyMsgContent);
                
                webEncrypt.encryptAndStoreInLocalStorage('ReplyMsgId', ReplyMsgId);
                
            
                stropheConnection.Connection()
                    .sendIQ(getReplymessage, module.exports.replyMessageCallBack);
            }
            webEncrypt.encryptAndStoreInLocalStorage('replymsgInfo', replymsgInfo);
            $('#comment').focus();
        }

        $(".replysingle").off("click");
        $(".replysingle").click(function () {
            let replymsgInfo = {};
            let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
            let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

            
            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let blockUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockUserInfo');
            
            let id = $(this).closest('.message-body').find('input:checkbox').attr('value');
            let result;
            if (id != '') {
                result = id.split('-');
                replymsgInfo[0] = {};
                replymsgInfo[0].keyid = result[0];
                replymsgInfo[0].type = result[1];
                let tojid = stropheConnection.Strophe().getNodeFromJid(module.exports.toJID());
                if (blockUserInfo != null && typeof blockUserInfo[tojid] != "undefined") {
                    return true;
    
                }else{
                   replymsgInfoIQSend(tojid,broadcastProfile,groupInfo,userInfo,result,replymsgInfo);
                }
                setTimeout(() => {
                    
                    module.exports.msgBoxDivHeight();
                }, 1000);
            }
        });
        $(".groupNameEdit").off("click");
        $(".groupNameEdit").click(function () {
            $('.groupname').css('display', 'none');
            $('.get-group-name').css('display', 'block');

            let text_max = 25;
            let text_length = $('.group-name').val().length;
            let text_remaining = text_max - text_length;
            $('.char-counter').html(text_remaining);
            $('#groupupdate-name').on('input', function () {
                let limitValue;
                text_length = $('#groupupdate-name').val().length;
                if (text_length <= 25) {
                    text_remaining = text_max - text_length;
                    $('.char-counter').html(text_remaining);
                } else {
                    limitValue = $('#groupupdate-name').val().substring(0, 25);
                    $('#groupupdate-name').val(limitValue);
                }
            });
        });
        $(".unstarmsg").off("click");
        $(".unstarmsg").click(function () {

            let id = $(this).closest('.message-body').find('input:checkbox').attr('value');
            let result,msgId;

            if (typeof id == 'undefined') {
                id = $(this).attr('id');
                $(this).closest(".staredmsg-sideBar").remove();
                result = id.split('-');
                msgId = result[1];
            } else {
                result = id.split('-');
                msgId = result[0];
            }

            if (id != '') {
                let updateStarmessage = stropheConnection
                    .StropheJs()
                    .$iq({
                        type: "set",
                        id: module.exports.getId(),
                        to: stropheConnection.Server()
                    })
                    .c("query", {
                        xmlns: "jabber:iq:user_fav",
                        status: "update_favourite_message",
                        message_id: msgId
                    });

                if (stropheConnection.Connection().connected) {
                    stropheConnection.Connection().send(updateStarmessage);
                }
            }

        });


        $(".message-info").off("click");
        $(".message-info").click(function () {
            $("#deliver-append-data").removeClass("listview");
            $("#read-append-data").removeClass("listview");
            $("#response-append-data").removeClass("listview");
            $("#acknowledge-append-data").removeClass("listview");
            $("#accept-append-data").removeClass("listview");
            $("#reject-append-data").removeClass("listview");
            $('.accordian').attr('src', './src/images/add_ic.svg');
            $('.accordian').removeClass('plus');
            $(".conversation").addClass("small-pane");
            let id = $(this).closest(".message-body").attr('id');
            $('.readby').html("");
            $('.deleiveredby').html("");
            $('.readby-status').html('');
            $('.deleiveredby-status').html('');
            $(".panel").hide();
            $("#seenmenu").removeClass("active");
            $("#deliverymenu").removeClass("active");
            $("#seenmenu").find(".close").css("display", "none");
            $("#seenmenu").find(".open").css("display", "block");
            $("#deliverymenu").find(".close").css("display", "none");
            $("#deliverymenu").find(".open").css("display", "block");
            let result = id.split("-");
            let ToJid = webEncrypt.getFromLocalStorageAndDecrypt('toJID');
            let nodeJid = stropheConnection.Strophe().getNodeFromJid(ToJid);

            let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
            let broadcastInfo = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');


            if(broadcastInfo != null && typeof broadcastInfo[nodeJid] != "undefined" && broadcastInfo[nodeJid][0] == "broadcast"){
                $(".grpAndBroadcastMsgInfoBody").show();
                $(".singleChatMsgInfoBody").hide();

                ToJid = stropheConnection.Server();
                let id = module.exports.randomString(16, 'a#');
                broadcastProfile.getBroadcastMsginfo(result[1], ToJid,id,true);
            }else if(groupInfo != null && typeof groupInfo[nodeJid] != "undefined" && groupInfo[nodeJid][0] == "group"){
                $(".grpAndBroadcastMsgInfoBody").show();
                $(".singleChatMsgInfoBody").hide();
                module.exports.getGroupMsginfo(result[1], ToJid,true);
            }else {
                $(".grpAndBroadcastMsgInfoBody").hide();
                $(".singleChatMsgInfoBody").show();
                ToJid = stropheConnection.Server();
                module.exports.getSingleMsginfo(result[1], ToJid,nodeJid);

            }

            let msg = typeof $(this).closest(".sender").html() !='undefined'?$(this).closest(".sender").html():$(this).closest(".receiver").html()
            let divcontent = '<div class="sender">' + msg + '</div><input type="hidden" name="messageid" value=""/>';
            $(".message-info-bubble").html(divcontent);
            $(".message-info-bubble").find('input[name="messageid"]').val(result[1]);
            $(".message-info-bubble").find('.dropdown').remove();
            
            $(".message-info-block").css({
                "right": "316px",
                "width": "316px",
              });
            $(".side-frd-profile").css({
                "right": "-100%",
                "width": "316px",
                "top": "0",
                "display": "block"
            });
            $("#userprofile").css({
                "width": "100%",
                "display": "block"
            });
            $(".infohead").css({
                "display": "none",
            });

            $(".message-info-bubble").find(".pButton").removeClass("pButton").addClass("npButton");
            if($('#updMessageInfo .ackClick').length <= 0){
                $('#updMessageInfo').addClass('priority-m');
            }

            if($('#updMessageInfo .btn-merge').length > 0){
                $('#updMessageInfo').addClass('pro-accept');
                $('#updMessageInfo').addClass('priority-m');
                module.exports.updMessageInfoDesignFun();

            }else {
                if($('#updMessageInfo .rejected').length > 0 || $('#updMessageInfo .accepted').length > 0 || $('#updMessageInfo .acknowledged').length > 0){
                    $('#updMessageInfo').addClass('pro-accept');
                    $('#updMessageInfo').addClass('priority-m');

                }else{
                    $('#updMessageInfo').removeClass('pro-accept');
                    $('#updMessageInfo').removeClass('priority-m');
                }

            }
            if($(this).closest('.receiver').length > 0){ // Receiver Msg Info Box
                $('#updMessageInfo').find('.sender').addClass('send-info')
                $('#updMessageInfo').find('.sender').addClass('receiver')

            }else { // Sender Msg Info Box
                $('#updMessageInfo').find('.sender').removeClass('send-info')

            }
            
        });
        $(".message-info-block .right-msg-back").click(function () {
            $(".conversation").removeClass("small-pane");
            $(".message-info-block").css({
                "right": "-100%"
            });
        });
        
        

        // function works on change function of siteDetails
        $("#sites-info").find('.select-message3').change(function () {
            
            let selectedSitesInfo = [];
            let index = 0;
            $('#sites-info .select-message3').each(function () {
                let id = (this.checked ? $(this).val() : "");
                if (id != '') {
                    selectedSitesInfo.push(id);
                    index++;
                }
            });

            if ($("#opened-side-profile").text() == "contacts")
                module.exports.setSiteSelectionDetails("0", selectedSitesInfo, "", "","", "");
            else if ($("#opened-side-profile").text() == "roles")
                module.exports.setSiteSelectionDetails("", "", "0", selectedSitesInfo,"", "");
            else if ($("#opened-side-profile").text() == "team")
                module.exports.setSiteSelectionDetails("", "", "", "","0", selectedSitesInfo);
            
        });
    },
    updMessageInfoDesignFun: function (){
        if($('#updMessageInfo .acknow-accept').length > 0){
            $('#updMessageInfo').addClass('pro-accept-rej');
        }else {
            $('#updMessageInfo').removeClass('pro-accept-rej');
        }
    },
    unstarmsg: function (starmsgId) {
        let divcontent = '<a  class="starmsg" >' + language.locali().star_message + '</a>';
        $("#fav-menu-" + starmsgId).html(divcontent);
        $('#chat-' + starmsgId).find('.fevorate').remove();
        module.exports.forwardmsg();
    },
    starmsg: function (starmsgId) {
        let divcontent = '<a  class="unstarmsg" >' + language.locali().unstar_message + '</a>';
        $("#fav-menu-" + starmsgId).html(divcontent);

        let favourite = '<i class="fevorate"><svg version="1.1" viewBox="0 0 19.481 19.481" enable-background="new 0 0 19.481 19.481"><g><path d="m10.201,.758l2.478,5.865 6.344,.545c0.44,0.038 0.619,0.587 0.285,0.876l-4.812,4.169 1.442,6.202c0.1,0.431-0.367,0.77-0.745,0.541l-5.452-3.288-5.452,3.288c-0.379,0.228-0.845-0.111-0.745-0.541l1.442-6.202-4.813-4.17c-0.334-0.289-0.156-0.838 0.285-0.876l6.344-.545 2.478-5.864c0.172-0.408 0.749-0.408 0.921,0z"></path></g></svg></i>';
        $('#chat-' + starmsgId).find('.message-time .msg-sent-time').prepend(favourite);

        module.exports.forwardmsg();
    },
    replyMessageCallBack: function (replyMessage) {
        if ($(replyMessage).find('chat').length) {
            let ReplyMsgContent = replyMessage;
            let messageFrom = $(replyMessage).find('chat').find('replyfromuser').text();
            let msgid = $(replyMessage).find('chat').find('msgid').text();
            let chatType = $(replyMessage).find('chat').find('chat_type').text();
            let msgbody = $(replyMessage).find('chat').find('body').text();
            let replyUser = $(replyMessage).find('chat').find('fromuser').text();
            let replymessageContent = JSON.parse(module.exports.decrypt(msgbody, msgid));
            let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
            if (chatType == 'normal') {
                messageFrom = stropheConnection.Strophe().getNodeFromJid(messageFrom);
                stropheConnection.Strophe().getNodeFromJid(replyUser);
            }else {
                let replymsgInfo = webEncrypt.getFromLocalStorageAndDecrypt('replymsgInfo');
                if (replymsgInfo != null) {
                    msgid = replymsgInfo[0].keyid;
                }
            }

            ReplyMsgContent = new XMLSerializer().serializeToString(ReplyMsgContent); //Convert XML to String
            webEncrypt.encryptAndStoreInLocalStorage('ReplyMsgContent', ReplyMsgContent);
            webEncrypt.encryptAndStoreInLocalStorage('ReplyMsgId', msgid);

        
            let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
            let profilename;
            profilename = module.exports.replyMsgGetProfileName(loginUserInfo,messageFrom,chatType,userInfo)

            let replymessageBodyContent = module.exports.sendreplymessage(replymessageContent, msgid, profilename);

            $(".reply-content").html('');
            $(".reply-content").html(replymessageBodyContent[1]);
            $(".reply-content").show();
            module.exports.replyCloseClick();
        }
    },

    replyMsgGetProfileName: function(loginUserInfo,messageFrom,chatType,userInfo){
        let profilename;
        if (loginUserInfo[0][0] == messageFrom || chatType == 'broadcast') {
            profilename = 'You';
        } else {
            if (userInfo != null && typeof userInfo[messageFrom] != "undefined") {
                profilename = module.exports.toTitleCase(userInfo[messageFrom][1]);
            } else {
                profilename = messageFrom;
            }
        }
        return profilename;
    },
    replyCloseClick: function () {
        $(".replyclose").off("click");
        $(".replyclose").click(function () {
            $(".reply-content").html('');
            $(".reply-content").hide();
            webEncrypt.deleteItemFromLocalStorage('replymsgInfo');
            module.exports.msgBoxDivHeight();

        });

    },
    getGroupMsginfo: function (msgid, ToJID) {
        let groupmsgiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            to: ToJID,
            id: module.exports.randomString(16, 'a#')
        }).c('query', {
            xmlns: 'jabber:iq:mixgroupchat',
            status: 'group_message_status',
            message_id: msgid
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(groupmsgiq, module.exports.groupmsgiqCallback);
        }
        // Indicate that this handler should be called repeatedly
        return true;
    },
    /** Single Chat Message Info IQ Trigger Function **/
    getSingleMsginfo: function (msgid, ToJID,nodeJid) {
        let singlemsgiq = stropheConnection.StropheJs().$iq({
            type: 'get',
            to: ToJID,
            id: module.exports.randomString(16, 'a#')
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            status: 'single_chat_message_status',
            message_id: msgid,
            to_user: nodeJid
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(singlemsgiq, module.exports.singleMsgIQCallback);
        }
        // Indicate that this handler should be called repeatedly
        return true;
    },

   
    groupmsIqMsgDesign: function(msg_ack){
        if (msg_ack == 0) {
            $('.response_list').hide();
        } else if (msg_ack == 1) {
            $('.response_list').show();
            $('.acknowledge_list').show();
            $('.accept_list').hide();
            $('.reject_list').hide();
        } else {
            $('.response_list').show();
            $('.acknowledge_list').hide();
            $('.accept_list').show();
            $('.reject_list').show();
        }
    },
    groupmsgIqsendCount: function(sendcount,loginUserInfo,user){
        if (loginUserInfo[0][0] != user) {
                sendcount++;
        }

        return sendcount;
    },
    groupmsgIqGetImg: function(imageId,mediaUrl,userToken){
        let image;
        if (imageId !== 'src/images/avatar/chat/profile_img_one.svg' && imageId.trim() !== '') {
            image = mediaUrl + imageId + "?mf=" + userToken;
            if (image.trim() == '' || image === undefined) {
                image = imageId;
            }
        } else if (imageId == '') {
            image = 'src/images/avatar/chat/profile_img_one.svg';
        }

        return image;
    },
    getDeleiverDateImageElement: function(user,image,displayName,time,concatedLetter){
        let deleiverdate;

        if (image == 'src/images/avatar/chat/profile_img_one.svg' || typeof(image) == 'undefined') {
            deleiverdate = '<li class="user-img"><div id="deliverAppendData-'+user+'" class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg></div></div><div class="delivered_details svgImgDeliverdDetails"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';

        }else {

            deleiverdate = '<li class="user-img"><img id="deliverAppendData-'+user+'" src="' + image + '"/><div class="delivered_details"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }

        return deleiverdate;

    },
    getReadDateImageElement: function(user,image,displayName,time,concatedLetter){
        let readdate;
        if(image == 'src/images/avatar/chat/profile_img_one.svg' || typeof(image) == 'undefined'){
            readdate = '<li class="user-img"><div id="deliverAppendData-'+user+'" class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg></div></div><div class="delivered_details svgImgReadDetails"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }else {
            readdate = '<li class="user-img"><img id="readAppendData-'+user+'" src="' + image + '"/><div class="delivered_details"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }

        return readdate;

    },
    groupmsgIqReandAndDelAppend: function(delAndReadObj){
        let timeOnly,date,time,readdate,deleiverdate;

        let deliver =  delAndReadObj.deliver,
        seen        =  delAndReadObj.seen,
        seentime    =  delAndReadObj.seentime,
        receivetime =  delAndReadObj.receivetime,
        user        =  delAndReadObj.user,
        image       =  delAndReadObj.image,
        displayName =  delAndReadObj.displayName,
        seencount   =  delAndReadObj.seencount,
        delivercount=  delAndReadObj.delivercount;

        let concatedLetter = module.exports.getImageDisplayText(displayName)

        if (parseInt(deliver) && parseInt(seen)) {
            timeOnly = timeFormat.convertTimestamp(seentime, 'created_at');
            date = new Date(seentime);
            time = date.getDate() + '-' + monthNames[date.getMonth()] + '-' + date.getFullYear() + ' at ' + timeOnly;
    
            readdate = module.exports.getReadDateImageElement(user,image,displayName,time,concatedLetter);

            $('#read-append-data').append(readdate);
            seencount++;
        }
        else if (parseInt(deliver)) {
            timeOnly = timeFormat.convertTimestamp(receivetime, 'created_at');
            date = new Date(receivetime);
            time = date.getDate() + '-' + monthNames[date.getMonth()] + '-' + date.getFullYear() + ' at ' + timeOnly;
           
            deleiverdate = module.exports.getDeleiverDateImageElement(user,image,displayName,time,concatedLetter);
            
            $('#deliver-append-data').append(deleiverdate);
            delivercount++;
        }

        let delAndSeenCountObj = {
            delivercount : delivercount,
            seencount : seencount
        }

        return delAndSeenCountObj;
    },
    getackAppendData: function(user,image,displayName,time,concatedLetter){
        let ackdate;
        if(image == 'src/images/avatar/chat/profile_img_one.svg' || typeof(image) == 'undefined'){
            ackdate = '<li class="user-img"><div id="acknowledgeAppendData-'+user+'" class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg></div></div><div class="delivered_details svgImgReadDetails"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }else {
            ackdate = '<li class="user-img"><img id="acknowledgeAppendImg-'+user+'" src="' + image + '"/><div class="delivered_details"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }

        return ackdate;
    },
    getaccAppendData: function(user,image,displayName,time,concatedLetter){
        let accdate;
        if(image == 'src/images/avatar/chat/profile_img_one.svg' || typeof(image) == 'undefined'){
            accdate = '<li class="user-img"><div id="acknowledgeAppendData-'+user+'" class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg></div></div><div class="delivered_details svgImgReadDetails"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }else {
            accdate = '<li class="user-img"><img id="acceptAppendImg-'+user+'" src="' + image + '"/><div class="delivered_details"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }

        return accdate;
    },
    getRejAppendData: function(user,image,displayName,time,concatedLetter){
        let rejdate;
        if(image == 'src/images/avatar/chat/profile_img_one.svg' || typeof(image) == 'undefined'){
            rejdate = '<li class="user-img"><div id="acknowledgeAppendData-'+user+'" class="col-sm-3 col-xs-3 sideBar-avatar"><div class="avatar-icon"><svg class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg></div></div><div class="delivered_details svgImgReadDetails"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>';
        }else {
            rejdate = '<li class="user-img"><img id="rejectAppendImg-'+user+'" src="' + image + '"/><div class="delivered_details"><span class="delivered_name">' + displayName + '</span><span class="delivered_time">' + time + '</span></div></li>'
        }

        return rejdate;
    },
    groupmsgIqGetAckAndAccRejCountObj: function(ackAndAccObj){
        let timeOnly,date,time,ackdate,accdate,rejdate;

        let tack        = ackAndAccObj.tack,
            msg_ack     = ackAndAccObj.msg_ack,
            acktime     = ackAndAccObj.acktime,
            user        = ackAndAccObj.user,
            image       = ackAndAccObj.image,
            displayName = ackAndAccObj.displayName,
            ackCount    = ackAndAccObj.ackCount,
            accCount    = ackAndAccObj.accCount,
            ackStatus   = ackAndAccObj.ackStatus,
            rejCount    = ackAndAccObj.rejCount;

        let concatedLetter = module.exports.getImageDisplayText(displayName)

        if (parseInt(tack) && (msg_ack == 1)) {
            timeOnly = timeFormat.convertTimestamp(acktime, 'created_at');
            date = new Date(acktime);
            time = date.getDate() + '-' + monthNames[date.getMonth()] + '-' + date.getFullYear() + ' at ' + timeOnly;
            if(typeof image != 'undefined' && image != 'src/images/avatar/chat/profile_img_one.svg' && image.trim() != ""){
                indexDb.blobImageConversion(image,'#acknowledgeAppendImg-'+user+'',user);

            }

            ackdate = module.exports.getackAppendData(user,image,displayName,time,concatedLetter)

           
            $('#acknowledge-append-data').append(ackdate);
            ackCount++;
        } else if (parseInt(tack) && (msg_ack == 2)) {
            timeOnly = timeFormat.convertTimestamp(acktime, 'created_at');
            date = new Date(acktime);
            time = date.getDate() + '-' + monthNames[date.getMonth()] + '-' + date.getFullYear() + ' at ' + timeOnly;
            if (ackStatus == 1) {
                
                accdate = module.exports.getaccAppendData(user,image,displayName,time,concatedLetter)
                $('#accept-append-data').append(accdate);
                accCount++;
            } else {
               
                rejdate = module.exports.getRejAppendData(user,image,displayName,time,concatedLetter)
                $('#reject-append-data').append(rejdate);
                rejCount++;
            }
        }

        let ackAndAccCountObj = {
            ackCount : ackCount,
            accCount : accCount,
            rejCount : rejCount
        }

        return ackAndAccCountObj;
    },
    groupmsgIqContentUpdate: function(countObj){
        let sendcount   =   countObj.sendcount,
            seencount   =   countObj.seencount,
            rCount      =   countObj.rCount,
            delivercount =  countObj.delivercount,
            dCount      =   countObj.dCount,
            aCount      =   countObj.aCount,
            ackCount    =   countObj.ackCount,
            accRejCount =   countObj.accRejCount;

        let content;
        if (sendcount != 0) {
            content = language.locali().Remaining + ' ' + sendcount;
            if (seencount != 0) {
                content = language.locali().Remaining + ' ' + rCount;
            }
            $('#read-count').html(content);
            if (delivercount != 0) {
                content = language.locali().Remaining + ' ' + dCount;
            }
            $('#deliver-count').html(content);
            if ((aCount != 0) && (ackCount != 0)) {
                content = language.locali().Remaining + ' ' + aCount;
            } else if ((aCount != 0) && (ackCount == 0)) {
                content = language.locali().Remaining + ' ' + accRejCount;
            }
            $('#response-count').html(content);
        }
    },
    groupmsgIqDelListShowHide: function(rCount){
        if (rCount == 0) {
            $('.deliver_list').hide();
        } else {
            $('.deliver_list').show();
        }
    },

    groupmsgIqStatusImgUpdate: function(statusImgObj){
       let ackStatus   =   statusImgObj.ackStatus,
            msgContent  =   statusImgObj.msgContent,
            receiptStatus = statusImgObj.receiptStatus,
            rtStatus    =   statusImgObj.rtStatus,
            atStatus    =   statusImgObj.atStatus,
            nodeJid     =   statusImgObj.nodeJid,
            msgid       =   statusImgObj.msgid;
        let statusImage,tstatusImage;
            if (ackStatus == "") {
                let loginUserId = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];

                if(loginUserId != msgContent){
                    statusImage = '';
                }else {
                    statusImage = receiptStatus;
                }

                tstatusImage = rtStatus;
            } else {
               
                let loginUserId = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo')[0][0];
                if(loginUserId != msgContent){
                    statusImage = ackStatus;

                }else {
                    statusImage = receiptStatus + ', ' + ackStatus;
                }

                tstatusImage = rtStatus + atStatus;
            }
            $("[id='"+nodeJid+"']").find('#' + msgid).parent().parent().find('.list-msg-status').html(statusImage);
            $("[id='"+nodeJid+"']").find('#' + msgid).parent().parent().find('.list-msg-status').append('<i class="tooltip-status">' + tstatusImage + '</i>');
    },

    groupmsgIqStatusAppend: function(statusAppendObj,msgFromUserName){
        let toJID   =   statusAppendObj.toJID,
            tDelivered  =   statusAppendObj.tDelivered,
            seencount   =   statusAppendObj.seencount,
            totalMem    =   statusAppendObj.totalMem,
            msg_ack     =   statusAppendObj.msg_ack,
            ackCount    =   statusAppendObj.ackCount,
            accCount    =   statusAppendObj.accCount,
            rejCount    =   statusAppendObj.rejCount,
            loggedUser  =   statusAppendObj.loggedUser,
            msgContent  =   statusAppendObj.msgContent,
            msgid       =   statusAppendObj.msgid;
        let nodeJid,receiptStatus,rtStatus,ackStatus,atStatus,totalMemberCnt;
        if (toJID != null && typeof toJID != "undefined") {
            nodeJid = stropheConnection.Strophe().getNodeFromJid(toJID);
            let recentChatMsgEl = $('#'+nodeJid).find('.time-msg-block')
            let recentChatMsgFromUser = recentChatMsgEl.attr('data-msgfrom')
            if(msgFromUserName == 'Switchboard' || recentChatMsgFromUser == 'Switchboard'){
                totalMemberCnt = totalMem;
            }else {
                totalMemberCnt = totalMem-1;

            }
            if ($("[id='"+nodeJid+"']").length) {

                receiptStatus = "<span class='receiptStatus'>Del'd <span class='deliveredCount'>" + tDelivered + "</span> of <span class='totalMembers'>" + (totalMemberCnt) + "</span>, Read <span class='readCount'>" + seencount + "</span> of <span class='totalMembers'>" + (totalMemberCnt) + "</span></span>";

                rtStatus = '<span class="deliverRecent">Delivered <span class="deliverCountRecent">' + tDelivered + '</span> of <span class="totalMemRecent">' + (totalMemberCnt) + '</span>,</span><span class="readRecent">Read <span class="readCountRecent">' + seencount + '</span> of <span class="totalMemRecent">' + (totalMemberCnt) + '</span>,</span>';

                if (msg_ack == 1) {
                    ackStatus = "<span class='ackStatus ackAccMainSpan'>Ack'd <span class='acknowledgeCount'>" + ackCount + "</span> of <span class='totalMembers'>" + (totalMemberCnt) + "</span></span>";

                    atStatus = '<span class="acknowledgeRecent">Acknowledged <span class="acknowledgeCountRecent">' + ackCount + '</span> of <span class="totalMemRecent">' + (totalMemberCnt) + '</span></span>';
                } else if (msg_ack == 2) {
                    ackStatus = "<span class='ackStatus ackAccMainSpan'>(Acc'd <span class='acceptCount'>" + accCount + "</span>, Rej'd <span class='rejectCount'>" + rejCount + "</span>) of <span class='totalMembers'>" + (totalMemberCnt) + "</span></span>";

                    atStatus = '<span class="acceptRecent">Accepted <span class="acceptCountRecent">' + accCount + '</span> of <span class="totalMemRecent">' + (totalMemberCnt) + '</span>,</span><span class="rejectRecent">Rejected <span class="rejectCountRecent">' + rejCount + '</span> of <span class="totalMemRecent">' + (totalMemberCnt) + '</span></span>';
                } else {
                    ackStatus = "";
                    atStatus = "";
                }

                let statusImgObj = {
                    ackStatus   :   ackStatus,
                    loggedUser  :   loggedUser,
                    msgContent  :   msgContent,
                    receiptStatus : receiptStatus,
                    rtStatus    :   rtStatus,
                    atStatus    :   atStatus,
                    nodeJid     :   nodeJid,
                    msgid       :   msgid

                }
                module.exports.groupmsgIqStatusImgUpdate(statusImgObj);
                
            }
        }
    },
    groupmsgIqAppendNoData(delivercount,seencount,ackCount,accCount,rejCount){
        let noData = '<span>...</span>';
        if (delivercount == 0) {
            $('#deliver-append-data').append(noData);
        }
        if (seencount == 0) {
            $('#read-append-data').append(noData);
        }
        if (ackCount == 0) {
            $('#acknowledge-append-data').append(noData);
        }
        if (accCount == 0) {
            $('#accept-append-data').append(noData);
        }
        if (rejCount == 0) {
            $('#reject-append-data').append(noData);
        }
    },
    /** Single Chat Message Info Callback Function **/

    singleMsgIQCallback: function(singlemsgiq){
        console.log("SingleMessageIQCallBack!!!!!");

        $(singlemsgiq).find('message_status').each(function () {
            let senttime = $(this).find('senttime').text();
            let seentime = $(this).find('seentime').text();
            let receivetime = $(this).find('receivetime').text();
            let acktime = $(this).find('acktime').text();
            let msg_ack = $(this).find('msg_ack').text();
            let ackStatus = $(this).find('ack_status').text();
            let msgResponseContent,msgResponseStatus;

            let sentimeOnly = timeFormat.convertTimestamp(senttime, 'created_at');
            let sentdate = new Date(senttime);
            let sentime = sentdate.getDate() + '-' + monthNames[sentdate.getMonth()] + '-' + sentdate.getFullYear() + ' at ' + sentimeOnly;
            $(".singleChatMsgInfoBody .sendTime").text(sentime)

            module.exports.getSingleChatMsgDeliverTimeApppend(receivetime)

            module.exports.getSingleChatMsgSeenTimeApppend(seentime)

            if(msg_ack != 0){
                if(msg_ack == 2){
                    let msgResponseObj = module.exports.getSingleChatMsgAccOrRejResponseObj(ackStatus,acktime)
                    msgResponseContent = msgResponseObj.msgResponseContent;
                    msgResponseStatus  = msgResponseObj.msgResponseStatus;
                    
                }else if(msg_ack == 1){
                    let msgResponseObj = module.exports.getSingleChatMsgAckResponseObj(ackStatus,acktime)
                    msgResponseContent = msgResponseObj.msgResponseContent;
                    msgResponseStatus  = msgResponseObj.msgResponseStatus;
                   
                }
                
                $(".singleChatMsgInfoBody .response_list").show();
                $(".singleChatMsgInfoBody .single_Responses").text(msgResponseContent)

                module.exports.SingleChatMsgAccAndRejTimeApppend(msgResponseStatus)

                
            }else {
                $(".singleChatMsgInfoBody .response_list").hide();

            }
           


        });
    },
    getSingleChatMsgDeliverTimeApppend: function(receivetime){
        $(".singleChatMsgInfoBody .deliver_list").show();
        if (parseInt(receivetime)) {
            let delivertimeOnly = timeFormat.convertTimestamp(receivetime, 'created_at');
            let deliverdate = new Date(receivetime);
            let delivertime = deliverdate.getDate() + '-' + monthNames[deliverdate.getMonth()] + '-' + deliverdate.getFullYear() + ' at ' + delivertimeOnly;

            $(".singleChatMsgInfoBody .deliverTime").text(delivertime)

        }else {
            $(".singleChatMsgInfoBody .deliverTime").text("Pending")
        }
    },
    getSingleChatMsgSeenTimeApppend: function(seentime){
        $(".singleChatMsgInfoBody .read_list").show();
        if (parseInt(seentime)) {
            let readtimeOnly = timeFormat.convertTimestamp(seentime, 'created_at');
            let readdate = new Date(seentime);
            let readtime = readdate.getDate() + '-' + monthNames[readdate.getMonth()] + '-' + readdate.getFullYear() + ' at ' + readtimeOnly;

            $(".singleChatMsgInfoBody .readTime").text(readtime);
        }else {
            $(".singleChatMsgInfoBody .readTime").text("Pending");
        }
    },
    SingleChatMsgAccAndRejTimeApppend: function(msgResponseStatus){
        if (msgResponseStatus != "Pending") {
            let ackOrRejtimeOnly = timeFormat.convertTimestamp(msgResponseStatus, 'created_at');
            let ackOrRejdate = new Date(msgResponseStatus);
            let ackOrRejtime = ackOrRejdate.getDate() + '-' + monthNames[ackOrRejdate.getMonth()] + '-' + ackOrRejdate.getFullYear() + ' at ' + ackOrRejtimeOnly;

            $(".singleChatMsgInfoBody .responseTime").text(ackOrRejtime)
        }else {
            $(".singleChatMsgInfoBody .responseTime").text(msgResponseStatus)

        }
    },
    getSingleChatMsgAckResponseObj: function(ackStatus,acktime){
        let msgResponseContent,msgResponseStatus;

        if(ackStatus == 0){
            msgResponseContent = "Acknowledged";
            msgResponseStatus  = "Pending";

        }else if(ackStatus == 1){
            msgResponseContent = "Acknowledged";
            msgResponseStatus  = acktime;
        }

        let msgResponseObj = {
            msgResponseContent,
            msgResponseStatus
        }

        return msgResponseObj;
    },
    getSingleChatMsgAccOrRejResponseObj: function(ackStatus,acktime){
        let msgResponseContent,msgResponseStatus;
        if(ackStatus == 0){
            msgResponseContent = "Accepted/Rejected";
            msgResponseStatus  = "Pending";
        }else if(ackStatus == 1){
            msgResponseContent = "Accepted";
            msgResponseStatus  =  acktime;
        }else if(ackStatus == 2){
            msgResponseContent = "Rejected";
            msgResponseStatus  =  acktime;
        }

        let msgResponseObj = {
            msgResponseContent,
            msgResponseStatus
        }

        return msgResponseObj;
    },
    groupmsgiqCallback: function (groupmsgiq) {
        
        let mediaUrl = window._env_.ApiURL + "/media/";
        let toJID = groupmsgiq.getAttribute("from");
        let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
        let loggedUser = loginUserInfo[0][0];
        $('#deliver-append-data').html('');
        $('#read-append-data').html('');
        $('#acknowledge-append-data').html('');
        $('#accept-append-data').html('');
        $('#reject-append-data').html('');
        $('#read-count').html('');
        $('#deliver-count').html('');
        $('#response-count').html('');

        let delivercount = 0;
        let sendcount = 0;
        let seencount = 0;
        let ackCount = 0;
        let accCount = 0;
        let rejCount = 0;
        let fromUser;
        let msgid,totalMem,msg_ack;
        $(groupmsgiq).find('query').each(function (index) {
            msgid = $(this).attr('message_id');
        });

        let msgFromUserName = $('#chat-'+msgid).attr('data-fromuser')

        totalMem = $(groupmsgiq).find('participants').length;
        $(groupmsgiq).find('participants').each(function () {
            fromUser = $(this).find('from_user').text();
            let user = $(this).find('user').text();
            let senttime = $(this).find('senttime').text();
            let seentime = $(this).find('seentime').text();
            let receivetime = $(this).find('receivetime').text();
            let acktime = $(this).find('acktime').text();
            msg_ack = $(this).find('msg_ack').text();
            let ackStatus = $(this).find('ack_status').text();

            let displayName = $(this).find('nickName').text();
            let imageId = $(this).find('image').text();

            module.exports.groupmsIqMsgDesign(msg_ack);

            let userToken = storage.getuserToken();
            let image;
            sendcount = module.exports.groupmsgIqsendCount(sendcount,loginUserInfo,user)

            image = module.exports.groupmsgIqGetImg(imageId,mediaUrl,userToken)
               
                let seen = seentime.split('-')[0];
                let deliver = receivetime.split('-')[0];
                let tack = acktime.split('-')[0];
                let sentimeOnly = timeFormat.convertTimestamp(senttime, 'created_at');
                let sentdate = new Date(senttime);
                let sentime = sentdate.getDate() + '-' + monthNames[sentdate.getMonth()] + '-' + sentdate.getFullYear() + ' at ' + sentimeOnly;
                $('#serversenttime').text(sentime);

                let delAndReadObj = {
                    deliver: deliver,
                    seen: seen,
                    seentime : seentime,
                    receivetime : receivetime,
                    user : user,
                    image : image,
                    displayName : displayName,
                    seencount : seencount,
                    delivercount : delivercount
                }
                   
              let delAndSeenCountObj =  module.exports.groupmsgIqReandAndDelAppend(delAndReadObj)
              delivercount = delAndSeenCountObj.delivercount;
              seencount = delAndSeenCountObj.seencount;

              let ackAndAccObj = {
                tack: tack,
                msg_ack: msg_ack,
                acktime : acktime,
                user : user,
                image : image,
                displayName : displayName,
                ackCount : ackCount,
                accCount : accCount,
                ackStatus : ackStatus,
                rejCount : rejCount
            }

            let ackAndAccRejCountObj =  module.exports.groupmsgIqGetAckAndAccRejCountObj(ackAndAccObj)
       
            ackCount = ackAndAccRejCountObj.ackCount;
            accCount = ackAndAccRejCountObj.accCount;
            rejCount = ackAndAccRejCountObj.rejCount;

        });

        if(msgFromUserName == 'Switchboard'){
            sendcount = totalMem
        }

        let tDelivered = delivercount + seencount;
        let dCount = sendcount - (delivercount + seencount);
        let rCount = sendcount - seencount;
        let aCount = sendcount - ackCount;
        let accRejCount = sendcount - (accCount + rejCount);

        let countObj = {
            sendcount   :   sendcount,
            seencount   :   seencount,
            rCount      :   rCount,
            delivercount :  delivercount,
            dCount      :   dCount,
            aCount      :   aCount,
            ackCount    :   ackCount,
            accRejCount :   accRejCount
        }

        module.exports.groupmsgIqContentUpdate(countObj)

        module.exports.groupmsgIqDelListShowHide(rCount)

        let statusAppendObj = {
            toJID   :   toJID,
            tDelivered  :   tDelivered,
            seencount   :   seencount,
            totalMem    :   totalMem,
            msg_ack     :   msg_ack,
            ackCount    :   ackCount,
            accCount    :   accCount,
            rejCount    :   rejCount,
            loggedUser  :   loggedUser,
            msgContent  :   fromUser,
            msgid       :   msgid

        }

        module.exports.groupmsgIqStatusAppend(statusAppendObj,msgFromUserName)
        
        module.exports.groupmsgIqAppendNoData(delivercount,seencount,ackCount,accCount,rejCount)

        $(".message-info-block").find(".profile-content").mCustomScrollbar('destroy');
        $(".message-info-block").find(".profile-content").mCustomScrollbar();
        return true;
    },
    checkMessageTypeText: function(messageContent,msgPriority){
        let msgcontent,type;
        msgcontent = "<i class='text-italic'>" + anchorme(minEmoji(messageContent.message), {
            attributes: [function (urlObj) {
                if (urlObj.protocol !== "mailto:") return {
                    name: "target",
                    value: "_blank"
                };
            }]
        }) + "</i>";

        if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
            type = "<span class='priority-message-recent'>" + language.locali().priority_recent + "</span> <i class='text-italic icon-name-status'></i><span class='inner-msg-txt'>" + messageContent.message + "</span>";
        } else {
            type = "<i class='text-italic icon-name-status'><span class='inner-msg-txt'>" + messageContent.message + "</span></i>";
        }

        msgcontent = '<div class="message-text"><div class="statictext" style="display:none;">' + messageContent.message + '</div>' + msgcontent + '</div>';

        let txtMsgContentObj = {
            msgcontent  :   msgcontent,
            type        :   type
        }

        return txtMsgContentObj;

    },
    checkMessageTypeVideo: function(messageContent,msgPriority,messageid){
        let msgcontent,type,filename,filesize,thumb,duration,thumburl,caption,file_url;

        filename = messageContent.media.file_name;
            filesize = messageContent.media.file_size;
            thumb = messageContent.media.thumb_image;
            duration = messageContent.media.duration;

            thumburl = 'data:image/png;base64,' + thumb;
            if (typeof messageContent.media.caption != "undefined") {
                caption = minEmoji(messageContent.media.caption);
                if (caption != "") {
                    caption = '<div class="image-caption" ><span class="emojitext selectable-text" >' + caption + '</span></div>';
                }
            }
            else {
                caption = '';
            }
            file_url = messageContent.media.file_url;

            msgcontent = '<div class="message-video media-canvas-component" id="video-' + messageid + '" style="width: 330px; height: 330px;" data-media-file="'+file_url+'"><p type="video" id="' + file_url + '" src="" ><img class="media-canvas thumbnail-img" src="' + thumburl + '"><button class="icon-play"></button></img><span class="duration">' + duration + '</span></p>';
            msgcontent = msgcontent + '<div class="image-caption-details"><span class="doc-thumb">' + thumb + '</span><span class="doc-details">' + filename + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span></div></div>' + caption;

            if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
                type = '<span class="priority-message-recent">PRIORITY</span><span class="name-status-icon"><i class="video-file text-italic"></i><span class="name-status">Video</span></span>';
            } else {
                type = '<span class="name-status-icon"><i class="video-file text-italic"></i><span class="name-status">Video</span></span>';
            }

            let videoMsgContentObj = {
                msgcontent  :   msgcontent,
                type        :   type
            }
    
            return videoMsgContentObj;
    },
    checkMessageTypeImage: function(messageContent,msgPriority,messageid){
        let mediaUrl = window._env_.ApiURL + "/media/";
        let userToken = storage.getuserToken();
        
        let msgcontent,type,filename,filesize,thumb,caption,file_url,imageContent;

        filename = messageContent.media.file_name;
        filesize = messageContent.media.file_size;
        thumb = messageContent.media.thumb_image;
        if (typeof messageContent.media.caption != "undefined") {
            caption = minEmoji(messageContent.media.caption);
            if (caption != "") {
                caption = '<div class="image-caption" ><span class="emojitext selectable-text" >' + caption + '</span></div>';
            }
        } else {
            caption = '';
        }
        file_url = messageContent.media.file_url;
        imageContent = mediaUrl + file_url + "?mf=" + userToken;

        indexDb.blobImageConversion(imageContent,'#chatImage-' + messageid +'',messageid,'chatImages');

        msgcontent = '<div class="message-img media-canvas-component" id="image-' + messageid + '" style="width: 330px; height: 330px;"><p class="media-canvas thumbnail-img" type="image" id="chatImage-' + messageid + '"  src="' + imageContent + '" style="background-image:url(' + imageContent + ')"></p><span class="doc-thumb">' + thumb + '</span><span class="doc-details">' + filename + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span></div>' + caption;

        if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
            type = '<span class="priority-message-recent">PRIORITY</span><span class="name-status-icon" ><i class="cam-ico text-italic"></i><span class="name-status">Photo</span></span>';
        } else {
            type = '<span class="name-status-icon"><i class="cam-ico text-italic"></i><span class="name-status">Photo</span></span>';
        }

        let imageMsgContentObj = {
            msgcontent  :   msgcontent,
            type        :   type
        }

        return imageMsgContentObj;
    },
    checkMessageTypeAudio: function(messageContent,msgPriority,messageid){
        let mediaUrl = window._env_.ApiURL + "/media/";
        let userToken = storage.getuserToken();
        let msgcontent,filesize,duration,file_url,type;
            file_url = messageContent.media.file_url;

            filesize = messageContent.media.file_size;
            duration = messageContent.media.duration;
            msgcontent = '<div class=" message-audio"><div class="bubble-audio-body"><span class="doc-thumb">' + duration + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span><audio id="' + messageid + '-music" preload="auto">';
            msgcontent = msgcontent + '<source type="audio/mpeg" id="' + file_url + '" class="chatAudioEl-'+messageid+'" src="' + mediaUrl + file_url + '?mf=' + userToken + '"></audio><div id="' + messageid + '-audioplayer" class = "audioplayer"> <button id="' + messageid + '-pButton" class="play pButton" ><svg class="playbbt" version="1.1" id="Capa_1" x="0px" y="0px" width="373.008px" height="373.008px" viewBox="0 0 373.008 373.008" style="enable-background:new 0 0 373.008 373.008;" xml:space="preserve"><g><g id="Layer_8_16_"><path d="M61.792,2.588C64.771,0.864,68.105,0,71.444,0c3.33,0,6.663,0.864,9.655,2.588l230.116,167.2c5.963,3.445,9.656,9.823,9.656,16.719c0,6.895-3.683,13.272-9.656,16.713L81.099,370.427c-5.972,3.441-13.334,3.441-19.302,0 c-5.973-3.453-9.66-9.833-9.66-16.724V19.305C52.137,12.413,55.818,6.036,61.792,2.588z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg><svg class="pausebbt" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 535.578 535.578" style="enable-background:new 0 0 535.578 535.578;" xml:space="preserve"> <g><g><g><path d="M231.6,516.278c0,10.658-8.641,19.3-19.3,19.3H106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z"/><path d="M448.728,516.278c0,10.658-8.641,19.3-19.3,19.3h-106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
            msgcontent = msgcontent + '<div id="' + messageid + '-timeline" class = "timeline" ><div id="' + messageid + '-playhead" class = "playhead"></div><div id="' + messageid + '-tracktime">' + duration + '</div></div></div><div class="audio-icon"><div class="icon icon-audio-file"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50"><defs><clipPath id="b"><rect width="50" height="50"/></clipPath></defs><g id="a" clip-path="url(#b)"><g transform="translate(1522.452 3497.027)"><path d="M22,1a21.006,21.006,0,0,0-8.174,40.35A21.006,21.006,0,0,0,30.174,2.65,20.868,20.868,0,0,0,22,1m0-1A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z" transform="translate(-1519.452 -3494.054)" fill="#ccc"/><g transform="translate(-1516.606 -3496)"><path d="M0,0H38.307V38.307H0Z" fill="none"/><g transform="translate(10.774 9.577)"><g transform="translate(7.183 24.541)"><path d="M32,59.788c-.552,0-1-.268-1-.6V55.6c0-.331.446-.6,1-.6s1,.268,1,.6V59.19C33,59.521,32.55,59.788,32,59.788Z" transform="translate(-31 -55)" fill="#ccc"/><path d="M32,60.288c-.854,0-1.5-.472-1.5-1.1V55.6c0-.626.644-1.1,1.5-1.1s1.5.472,1.5,1.1V59.19C33.5,59.816,32.852,60.288,32,60.288Zm-.5-1.139a.961.961,0,0,0,1,0v-3.51a.961.961,0,0,0-1,0Z" transform="translate(-31 -55)" fill="#ccc"/></g><g transform="translate(0 16.76)"><path d="M26.38,50.978A8.389,8.389,0,0,1,18,42.6a.6.6,0,0,1,1.2,0,7.183,7.183,0,1,0,14.365,0,.6.6,0,0,1,1.2,0A8.389,8.389,0,0,1,26.38,50.978Z" transform="translate(-18 -42)" fill="#ccc"/><path d="M26.38,51.978A9.39,9.39,0,0,1,17,42.6a1.6,1.6,0,0,1,3.2,0,6.183,6.183,0,1,0,12.365,0,1.6,1.6,0,0,1,3.2,0A9.39,9.39,0,0,1,26.38,51.978Z" transform="translate(-18 -42)" fill="#ccc"/></g><path d="M30.183,29.168a.6.6,0,1,1,0-1.2h3.591V25.577H30.183a.6.6,0,0,1,0-1.2h3.591V21.986H30.183a.6.6,0,0,1,0-1.2h3.556a5.386,5.386,0,0,0-10.739.6V32.76a5.387,5.387,0,1,0,10.774,0V29.168Z" transform="translate(-20.007 -16)" fill="#ff6b19"/></g></g></g></g></svg></div></div></div></div>';
            
            if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
                type = "<span class='priority-message-recent'>PRIORITY</span><i class='microphone text-italic'></i><span class='name-status'>Audio</span>";
            } else {
                type = "<i class='microphone text-italic'></i><span class='name-status'>Audio</span>";
            }
            indexDb.blobImageConversion(mediaUrl + file_url + '?mf=' + userToken,'.chatAudioEl-'+messageid+'',messageid,'chatAudios');
   
            let audioMsgContentObj = {
                msgcontent  :   msgcontent,
                type        :   type
            }
    
            return audioMsgContentObj;
    },
    checkMessageTypeFile: function(messageContent,msgPriority){
        let msgcontent,type,filename,filesize,file_url;
        filename = messageContent.media.file_name;
            file_url = messageContent.media.file_url;
            let msgtype_sas = file_url.substr((file_url.lastIndexOf('.') + 1));
            let msgtype = msgtype_sas.split("?")[0];
            let typeimage;
            filesize = messageContent.media.file_size;
            if (msgtype == 'pdf' || msgtype == 'PDF') {
                typeimage = 'icon-doc-pdf';
            } else if (msgtype == "xls" || msgtype == 'xlsx') {
                typeimage = 'icon-doc-xls';
            } else if (msgtype == "txt") {
                typeimage = 'icon-doc-txt';
            } else {
                typeimage = 'icon-doc-dox';
            }
            let contentdiv = '<div class="message-doc"><a class="document-container ikonixFileDownload" download="' + filename + '" id="' + file_url + '" title="' + filename + '"  href="javascript:void(0)">';
            contentdiv = contentdiv + '<div class="document-body"><div class="document-icon"><div class="icon-doc ' + typeimage + '"></div></div>';
            contentdiv = contentdiv + '<div class="document-text"><span class="doc-title">' + filename + '</span>';
            contentdiv = contentdiv + '</div><div class="doc-state"><span class="doc-state-icon"><svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 490.4 490.4" style="enable-background:new 0 0 490.4 490.4;" xml:space="preserve"><g><g><path d="M490.4,245.2C490.4,110,380.4,0,245.2,0S0,110,0,245.2s110,245.2,245.2,245.2S490.4,380.4,490.4,245.2z M24.5,245.2c0-121.7,99-220.7,220.7-220.7s220.7,99,220.7,220.7s-99,220.7-220.7,220.7S24.5,366.9,24.5,245.2z"/><path d="M253.9,360.4l68.9-68.9c4.8-4.8,4.8-12.5,0-17.3s-12.5-4.8-17.3,0l-48,48V138.7c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3v183.4l-48-48c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l68.9,68.9c2.4,2.4,5.5,3.6,8.7,3.6S251.5,362.8,253.9,360.4z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>';
            contentdiv = contentdiv + '</div></div></a><div class="document-details">';
            msgcontent = contentdiv + '<span class="doc-details">' + msgtype + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span></div></div>';

            let fileSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <rect width="20" height="20" fill="white"/>
                                <rect x="4.71429" y="4.42857" width="12.8571" height="14.5714" rx="0.857143" fill="#838383"/>
                                <rect x="3" y="1" width="12.8571" height="16.2857" rx="0.857143" fill="white"/>
                                <path d="M3 2.71427C3 2.24089 3.38376 1.85713 3.85714 1.85713H14.1429C14.6162 1.85713 15 2.24089 15 2.71427V15.5714C15 16.0448 14.6162 16.4286 14.1429 16.4286H3.85714C3.38376 16.4286 3 16.0448 3 15.5714V2.71427Z" fill="#838383"/>
                                <rect x="5.57144" y="7.85715" width="6.85714" height="0.857143" fill="white"/>
                                <rect x="5.57144" y="10.4286" width="6.85714" height="0.857143" fill="white"/>
                                <rect x="5.57144" y="13" width="3.42857" height="0.857143" fill="white"/>
                                <path d="M3 1.85713H7.28571V5.2857C7.28571 5.75909 6.90196 6.14285 6.42857 6.14285H3V1.85713Z" fill="white"/>
                                <path d="M6.54679 4.85713C6.54679 5.09383 6.35491 5.28571 6.11822 5.28571L3.32515 5.28571C3.24879 5.28571 3.21055 5.19338 3.26454 5.13939L6.40046 2.00346C6.45446 1.94946 6.54678 1.9877 6.54678 2.06407L6.54679 4.85713Z" fill="#838383"/>
                            </svg>`;

            if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
                type = "<span class='priority-message-recent'>PRIORITY</span><span class='file-type name-status name-status-icon'>"+fileSvg+" File</span>";
            } else {
                type = "<span class='file-type name-status name-status-icon'>"+fileSvg+" File</span>";
            }

            let fileMsgContentObj = {
                msgcontent  :   msgcontent,
                type        :   type
            }
    
            return fileMsgContentObj;
    },
    checkMessageTypeContact: function(messageContent,msgPriority){
        let msgcontent,type;

        msgcontent = '<div class="message-contact message-vcard"><div class="contact-body"><div class="avatar-icon"><svg version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve" class=""><g><g><g id="account-circle"> <path d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M255,76.5    c43.35,0,76.5,33.15,76.5,76.5s-33.15,76.5-76.5,76.5c-43.35,0-76.5-33.15-76.5-76.5S211.65,76.5,255,76.5z M255,438.6    c-63.75,0-119.85-33.149-153-81.6c0-51,102-79.05,153-79.05S408,306,408,357C374.85,405.45,318.75,438.6,255,438.6z" data-original="#000000" class="active-path" data-old_color="#000000"/></g> </g></g> </svg>';
            msgcontent = msgcontent + '</div><div class="document-text"><span class="doc-title cont-name">' + messageContent.contact.name + '</span><span class="cont-number"> ' + module.exports.formatnumber(messageContent.contact.phone_number[0]) + '</span></div></div></div>';

            let contactSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <rect width="20" height="20" fill="white"/>
                                <rect x="3.46155" y="1.5" width="15.0385" height="17" rx="2.67483" fill="#7F7F7F"/>
                                <path d="M13.9133 12.1908C13.9133 12.3062 13.8871 12.4249 13.8316 12.5404C13.776 12.6559 13.7041 12.7649 13.6093 12.8676C13.4491 13.0408 13.2725 13.1659 13.0731 13.246C12.877 13.3262 12.6645 13.3679 12.4356 13.3679C12.1021 13.3679 11.7458 13.2909 11.3698 13.1338C10.9939 12.9766 10.6179 12.7649 10.2452 12.4987C9.86926 12.2293 9.51291 11.9309 9.17291 11.6006C8.83618 11.267 8.53214 10.9174 8.2608 10.5517C7.99272 10.186 7.77695 9.82038 7.62003 9.45793C7.46311 9.09227 7.38464 8.74265 7.38464 8.40906C7.38464 8.19095 7.42387 7.98246 7.50234 7.79C7.5808 7.59434 7.70503 7.41472 7.8783 7.25434C8.08753 7.05227 8.31637 6.95284 8.5583 6.95284C8.64984 6.95284 8.74137 6.97208 8.8231 7.01057C8.9081 7.04906 8.9833 7.1068 9.04214 7.19019L9.8006 8.23906C9.85945 8.31925 9.90195 8.39302 9.93137 8.46359C9.9608 8.53095 9.97714 8.59831 9.97714 8.65925C9.97714 8.73623 9.95426 8.81321 9.90849 8.88699C9.86599 8.96076 9.80387 9.03774 9.72541 9.11472L9.47695 9.36812C9.44099 9.4034 9.42464 9.4451 9.42464 9.49642C9.42464 9.52208 9.42791 9.54453 9.43445 9.57019C9.44426 9.59585 9.45407 9.6151 9.4606 9.63434C9.51945 9.74019 9.6208 9.87812 9.76464 10.0449C9.91176 10.2117 10.0687 10.3817 10.2387 10.5517C10.4152 10.7217 10.5852 10.8789 10.7585 11.0232C10.9285 11.1643 11.0691 11.2606 11.1802 11.3183C11.1966 11.3247 11.2162 11.3343 11.2391 11.344C11.2652 11.3536 11.2914 11.3568 11.3208 11.3568C11.3764 11.3568 11.4189 11.3376 11.4548 11.3023L11.7033 11.0617C11.785 10.9815 11.8635 10.9206 11.9387 10.8821C12.0139 10.8372 12.0891 10.8147 12.1708 10.8147C12.2329 10.8147 12.2983 10.8276 12.3702 10.8564C12.4421 10.8853 12.5173 10.927 12.5991 10.9815L13.6812 11.7353C13.7662 11.793 13.825 11.8604 13.861 11.9406C13.8937 12.0208 13.9133 12.1009 13.9133 12.1908Z" fill="white"/>
                                <path d="M14.1154 3.74529H15.6329C16.4941 3.74529 17.1923 4.44346 17.1923 5.30471V15.3368C17.1923 16.1981 16.4941 16.8962 15.6329 16.8962H13.9231L14.7894 16.655C15.3836 16.4895 15.7947 15.9483 15.7947 15.3314V15.3314V11.275V5.75V5.75C15.7947 5.22678 15.5388 4.73664 15.1094 4.43761L14.1154 3.74529Z" fill="white"/>
                                <rect x="1.5" y="5.34906" width="3.825" height="2.05962" rx="1.02981" fill="white"/>
                                <path d="M2.08847 6.37886C2.08847 6.13511 2.28607 5.93752 2.52982 5.93752H4.2952C4.53895 5.93752 4.73655 6.13511 4.73655 6.37886V6.37886C4.73655 6.62261 4.53895 6.82021 4.2952 6.82021H2.52982C2.28607 6.82021 2.08847 6.62261 2.08847 6.37886V6.37886Z" fill="#7F7F7F"/>
                                <rect x="1.5" y="8.5856" width="3.825" height="2.05962" rx="1.02981" fill="white"/>
                                <path d="M2.08847 9.6154C2.08847 9.37165 2.28607 9.17406 2.52982 9.17406H4.2952C4.53895 9.17406 4.73655 9.37165 4.73655 9.6154V9.6154C4.73655 9.85915 4.53895 10.0567 4.2952 10.0567H2.52982C2.28607 10.0567 2.08847 9.85915 2.08847 9.6154V9.6154Z" fill="#7F7F7F"/>
                                <rect x="1.5" y="11.8221" width="3.825" height="2.05962" rx="1.02981" fill="white"/>
                                <path d="M2.08847 12.8519C2.08847 12.6082 2.28607 12.4106 2.52982 12.4106H4.2952C4.53895 12.4106 4.73655 12.6082 4.73655 12.8519V12.8519C4.73655 13.0957 4.53895 13.2933 4.2952 13.2933H2.52982C2.28607 13.2933 2.08847 13.0957 2.08847 12.8519V12.8519Z" fill="#7F7F7F"/>
                            </svg>`;

            if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
                type = "<span class='priority-message-recent'>PRIORITY</span><span class='file-type name-status name-status-icon'>"+contactSvg+" Contact</span>";
            } else {
                type = "<span class='file-type name-status name-status-icon'>"+contactSvg+" Contact</span>";
            }

            let ContactMsgContentObj = {
                msgcontent  :   msgcontent,
                type        :   type
            }
    
            return ContactMsgContentObj;
    },
    checkMessageTypeLocation: function(messageContent,msgPriority){
        let msgcontent,type,file_url;

        let Settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');
        let longitude = messageContent.location.longitude;
        let latitude = messageContent.location.latitude;
        file_url = "https://maps.googleapis.com/maps/api/staticmap?center=" + latitude + "," + longitude + "&zoom=13&size=200x200&markers=color:red|" + latitude + "," + longitude + "&key="+Settings.googleMapKey+"";
        msgcontent = '<div class="message-location"><a target="_blank" href="https://www.google.com/maps/?q=' + latitude + "," + longitude + '"><img src="' + file_url + '"/></a><span class="loc-latitude">' + latitude + '</span><span class="loc-longitude">' + longitude + '</span></div>';

         let locationSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M17.1833 7.04166C16.3083 3.19166 12.95 1.45833 9.99999 1.45833C9.99999 1.45833 9.99999 1.45833 9.99165 1.45833C7.04999 1.45833 3.68332 3.18333 2.80832 7.03333C1.83332 11.3333 4.46665 14.975 6.84999 17.2667C7.73332 18.1167 8.85832 19.8077 9.99165 19.8077C11.125 19.8077 12.2667 18.1167 13.1417 17.2667C15.525 14.975 18.1583 11.3417 17.1833 7.04166ZM9.99999 11.2167C8.54999 11.2167 7.37499 10.0417 7.37499 8.59166C7.37499 7.14166 8.54999 5.96666 9.99999 5.96666C11.45 5.96666 12.625 7.14166 12.625 8.59166C12.625 10.0417 11.45 11.2167 9.99999 11.2167Z" fill="#7F7F7F"/>
                            </svg>`;

        if(typeof(msgPriority) != "undefined" && msgPriority == 2) {
           
            type = "<span class='priority-message-recent'>PRIORITY</span><span class='file-type name-status name-status-icon'> "+locationSvg+" Location</span>";
        } else {
            type = "<span class='file-type name-status name-status-icon'>"+locationSvg+" Location</span>";
        }
        let LocationMsgContentObj = {
            msgcontent  :   msgcontent,
            type        :   type
        }

        return LocationMsgContentObj;
    },
    checkMessageType: function (messageContent, messageid, msgPriority) {
        let msgcontent,type;
        if (messageContent.message_type == "text" || messageContent.message_type == "auto_text") {

           let txtMsgContentObj =  module.exports.checkMessageTypeText(messageContent,msgPriority);
           msgcontent  =   txtMsgContentObj.msgcontent;
           type        =   txtMsgContentObj.type;
            
        } else if (messageContent.message_type == "video") {
           let videoMsgContentObj =  module.exports.checkMessageTypeVideo(messageContent,msgPriority,messageid);

           msgcontent  =   videoMsgContentObj.msgcontent;
           type        =   videoMsgContentObj.type;

        } else if (messageContent.message_type == "image") {
            let imageMsgContentObj =  module.exports.checkMessageTypeImage(messageContent,msgPriority,messageid);
            msgcontent  =   imageMsgContentObj.msgcontent;
            type        =   imageMsgContentObj.type;
          
        } else if (messageContent.message_type == "audio") {
            let audioMsgContentObj =  module.exports.checkMessageTypeAudio(messageContent,msgPriority,messageid);
            msgcontent  =   audioMsgContentObj.msgcontent;
            type        =   audioMsgContentObj.type;
            

        } else if (messageContent.message_type == "file") {
            let fileMsgContentObj =  module.exports.checkMessageTypeFile(messageContent,msgPriority);
            msgcontent  =   fileMsgContentObj.msgcontent;
            type        =   fileMsgContentObj.type;

        } else if (messageContent.message_type == "contact") {
            let ContactMsgContentObj =  module.exports.checkMessageTypeContact(messageContent,msgPriority);

            msgcontent  =   ContactMsgContentObj.msgcontent;
            type        =   ContactMsgContentObj.type;
        } else if (messageContent.message_type == "location") {
            let LocationMsgContentObj =  module.exports.checkMessageTypeLocation(messageContent,msgPriority);
            msgcontent  =   LocationMsgContentObj.msgcontent;
            type        =   LocationMsgContentObj.type;
            
        }
        return [type, msgcontent, messageContent.message_type];
    },
    getreplymessageClassName: function(MessageDeleted){
        let className;
        if (MessageDeleted) {
            className = '';
        } else {
            className = 'replycontent ';
        }

        return className;
    },
    getreplymessageTxtObj: function(messageContent, messageid, Profile,className){
        let text_length,msgcontent,textmsg;

        text_length = messageContent.message.length;
        if (text_length <= 250) {

            textmsg = messageContent.message;
        } else {
            textmsg = messageContent.message.substring(0, 250) + "....";

        }
        msgcontent = '<div id="replycontent-' + messageid + '" class="' + className + 'statictext replaymsg"><a class="receivefrom">' + Profile + '</a>' + textmsg + '</div>';

        return msgcontent;
    },
    getreplymessageVideoObj: function(messageContent, messageid, Profile,className){
        let msgcontent,thumb,thumburl;

        thumb = messageContent.media.thumb_image;
        thumburl = 'data:image/png;base64,' + thumb;
        msgcontent = '<div id="replycontent-' + messageid + '" class="' + className + 'reply-message-img"><div class="imagereply"><a class="receivefrom">' + Profile + '</a><div class="image-info"> <i class="video-file text-italic"></i><span class="name-status">Video</span></div></div><div class="message-video "><img class="media-canvas thumbnail-img" src="' + thumburl + '"></img></div>';

        return msgcontent;

    },
    getreplymessageImgObj(messageContent, messageid, Profile){
        let mediaUrl = window._env_.ApiURL + "/media/";
        let userToken = storage.getuserToken();
        let msgcontent,file_url;
        file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;

        indexDb.blobImageConversion(file_url,'#replyChatImage-' + messageid +'',messageid,'chatImages');

        msgcontent = '<div id="replycontent-' + messageid + '" class="replycontent reply-message-img"><div class="imagereply"><a class="receivefrom">' + Profile + '</a><div class="image-info"> <i class="cam-ico text-italic"></i><span class="name-status">Photo</span></div></div><div class="message-img media-canvas-component"><p id="replyChatImage-' + messageid + '" class="media-canvas thumbnail-img" type="image"  src="' + file_url + '" style="background-image:url(' + file_url + ')"></p></div></div>';

        return msgcontent;

    },
    getreplymessageAudioObj(messageContent, messageid, Profile,className){
        let msgcontent,duration;

        duration = messageContent.media.duration;
        msgcontent = '<div id="replycontent-' + messageid + '" class="' + className + 'reply-message-audio"><a class="receivefrom">' + Profile + '</a><div class="reply-audio"><div class="audio-icon"><div class="icon icon-audio-file"><svg version="1.1" id="Capa_1"  x="0px" y="0px" width="287.386px" height="287.386px" viewBox="0 0 287.386 287.386" style="enable-background:new 0 0 287.386 287.386;" xml:space="preserve"><g><g><path d="M62.743,155.437v98.42c0,5.867,4.741,10.605,10.605,10.605c5.854,0,10.605-4.738,10.605-10.605v-98.42c0-5.856-4.751-10.605-10.605-10.605C67.484,144.832,62.743,149.576,62.743,155.437z"/><path d="M29.456,264.582h23.351v-116.85c0.064-0.56,0.166-1.119,0.166-1.693c0-50.412,40.69-91.42,90.698-91.42c50.002,0,90.692,41.008,90.692,91.42c0,0.771,0.113,1.518,0.228,2.263v116.28h23.354c16.254,0,29.442-13.64,29.442-30.469v-60.936c0-13.878-8.989-25.57-21.261-29.249c-1.129-66.971-55.608-121.124-122.45-121.124 c-66.86,0-121.347,54.158-122.465,121.15C8.956,147.638,0,159.32,0,173.187v60.926C0,250.932,13.187,264.582,29.456,264.582z"/><path d="M203.454,155.437v98.42c0,5.867,4.748,10.605,10.604,10.605s10.604-4.738,10.604-10.605v-98.42c0-5.856-4.748-10.605-10.604-10.605C208.191,144.832,203.454,149.576,203.454,155.437z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div></div><div>' + duration + '</div></div></div>';

        return msgcontent;
    },
    getreplymessageFileObj: function(messageContent, messageid, Profile){
        let msgcontent,filename,filesize,file_url,msgtype;

        filename = messageContent.media.file_name;
        file_url = messageContent.media.file_url;
        msgtype = file_url.substr((file_url.lastIndexOf('.') + 1));
        filesize = messageContent.media.file_size;
        let typeimage;
        if (msgtype == 'pdf' || msgtype == 'PDF') {
            typeimage = 'icon-doc-pdf';
        } else {
            typeimage = 'icon-doc-dox';
        }
        let contentdiv = '<div id="replycontent-' + messageid + '" class="replycontent message-doc reply-doc"><a class="document-container" download="' + filename + '"  title="' + filename + '" href="javascript:void();">';
        contentdiv = contentdiv + '<div class="document-body"><p class="receivefrom">' + Profile + '</p><div class="document-info"><div class="document-icon"><div class="ic-doc ' + typeimage + '"></div></div>';
        contentdiv = contentdiv + '<div class="document-text"><span class="doc-title">' + filename + '</span>';
        contentdiv = contentdiv + '</div>';
        contentdiv = contentdiv + '</div></div></a><div class="document-details">';
        msgcontent = contentdiv + '<span class="doc-details">' + msgtype + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span></div></div>';

        return msgcontent;
    },
    getreplymessageContactObj: function(messageContent, messageid, Profile){
        let msgcontent;

        msgcontent = '<div id="replycontent-' + messageid + '" class="replycontent message-contact message-vcard"><div class="contact-container" title="#" href="javascript:void();"><div class="contact-body reply-contact"><div class="mainavatar-info"><a class="receivefrom">' + Profile + '</a><div class="avatar-info"><div class="avatar-ic">';
        msgcontent = msgcontent + '</div><div class="document-text"><span class="doc-title cont-name">' + messageContent.contact.name + '</span></div></div></div></div></div>';

        return msgcontent;

    },
    getreplymessageLocationObj: function(messageid, Profile,className){
        let msgcontent;

        let Settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');

        msgcontent = '<div id="replycontent-' + messageid + '" class="' + className + 'message-location location-reply"><div class="location-reply-info"><a class="receivefrom">' + Profile + '</a><div class="location-info"><i class="loc-ic"></i>location</div></div><div class="location-map"><a target="_blank" href="https://www.google.com/maps/?q=13.0154998,80.2004422"><img src="https://maps.googleapis.com/maps/api/staticmap?center=13.0154998,80.2004422&amp;zoom=13&amp;size=200x200&amp;markers=color:red|13.0154998,80.2004422&amp;key='+Settings.googleMapKey+'"></a></div></div>';

        return msgcontent;

    },
    getreplymessage: function (messageContent, messageid, Profile,MessageDeleted) {
        let className,msgcontent;
        className =  module.exports.getreplymessageClassName(MessageDeleted)
        
        if (messageContent.message_type == "text" || messageContent.message_type == "auto_text") {
           msgcontent = module.exports.getreplymessageTxtObj(messageContent, messageid, Profile,className);
            
        } else if (messageContent.message_type == "video") {
           msgcontent = module.exports.getreplymessageVideoObj(messageContent, messageid, Profile,className);

        } else if (messageContent.message_type == "image") {
           msgcontent = module.exports.getreplymessageImgObj(messageContent, messageid, Profile);

            
        } else if (messageContent.message_type == "audio") {
            msgcontent = module.exports.getreplymessageAudioObj(messageContent, messageid, Profile,className);

           
        } else if (messageContent.message_type == "file") {
            msgcontent = module.exports.getreplymessageFileObj(messageContent, messageid, Profile);
           
        } else if (messageContent.message_type == "contact") {
            msgcontent = module.exports.getreplymessageContactObj(messageContent, messageid, Profile);

            
        } else if (messageContent.message_type == "location") {
            msgcontent = module.exports.getreplymessageLocationObj(messageid, Profile,className);

          
        }
        return [messageContent.message_type, msgcontent];
    },
    getfavTxtMsg: function(text_length,messageContent){
        let textmsg;
        if (text_length <= 25) {

            textmsg = messageContent.message;
        } else {
            textmsg = messageContent.message.substring(0, 25) + "....";

        }

        return textmsg;
    },
    getfavCaptionTxt: function(messageContent){
        let text_length,caption;
        if (typeof messageContent.media.caption != "undefined") {
            caption = minEmoji(messageContent.media.caption);
            if (caption != "") {
                text_length = caption.length;
                if (text_length > 500) {
                    caption = caption.substring(0, 500) + '...';
                }
                caption = '<div class="image-caption" ><span class="emojitext selectable-text" >' + caption + '</span></div>';
            }
        } else {
            caption = '';
        }

        return caption;
    },
    getfavVideoCaptionTxt: function(messageContent){
        let caption,text_length;
        if (typeof messageContent.media.caption != "undefined") {
            caption = minEmoji(messageContent.media.caption);
            if (caption != "") {
                text_length = caption.length;
                if (text_length > 500) {
                    caption = caption.substring(0, 500) + '...';
                }
                caption = '<div class="image-caption" ><span class="emojitext selectable-text" >' + caption + '</span></div>';
            }
        }
        else {
            caption = '';
        }

        return caption;
    },
    getfavFileTypeImg: function(msgtype){
        let typeimage;
        if (msgtype == 'pdf' || msgtype == 'PDF') {
            typeimage = 'icon-doc-pdf';
        } else if (msgtype == 'xls' || msgtype == 'XLS' || msgtype == 'xlsx' || msgtype == 'XLSX'){
            typeimage = 'icon-doc-xls';
        } else {
            typeimage = 'icon-doc-dox';
        }

        return typeimage;
    },
    getfavmessage: function (messageContent, messageid, displayName) {
        let mediaUrl = window._env_.ApiURL + "/media/";
        let filePath = '';
        let userToken = storage.getuserToken();
        let text_length,textmsg,msgcontent,filename,filesize,thumb,file_url,caption,thumburl,longitude,latitude,duration,msgtype,contentdiv;
        if (messageContent.message_type == "text" || messageContent.message_type == "auto_text") {

            text_length = messageContent.message.length;

            textmsg =  module.exports.getfavTxtMsg(text_length,messageContent)
           
            msgcontent = '<a class="receivefrom">' + displayName + '</a><div id="starredmsgcontent-' + messageid + '" class="starredcontent statictext starredmsg">' + textmsg + '</div>';
        }
        else if (messageContent.message_type == "image") {
            filePath = messageContent.media.file_url;
            filename = messageContent.media.file_name;
            filesize = messageContent.media.file_size;
            thumb = messageContent.media.thumb_image;
            file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;

            caption =  module.exports.getfavCaptionTxt(messageContent)

            

            indexDb.blobImageConversion(file_url,'#favoriteImage-' + messageid +'',messageid,'chatImages');

            msgcontent = '<a class="receivefrom">' + displayName + '</a><div id="starredmsgcontent-' + messageid + '" class="starredcontent message-img media-canvas-component"  style="width: 330px; height: 186px;"><p id="favoriteImage-' + messageid + '" class="media-canvas thumbnail-img" type="image" src="' + file_url + '" style="background-image:url(' + file_url + ')"></p><span class="doc-thumb">' + thumb + '</span><span class="doc-details">' + filename + '</span><span class="doc-size">' + filesize + '</span></div>' + caption;
        }
        else if (messageContent.message_type == "video") {
            filePath = messageContent.media.file_url;
            thumb = messageContent.media.thumb_image;
            thumburl = 'data:image/png;base64,' + thumb;
            file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;
            filename = messageContent.media.fileName;
            filesize = messageContent.media.file_size;

            caption =  module.exports.getfavVideoCaptionTxt(messageContent);

            
            msgcontent = '<a class="receivefrom">' + displayName + '</a><div id="starredmsgcontent-' + messageid + '" class="starredcontent message-video media-canvas-component" style="width: 330px; height: 330px;" data-media-file="'+file_url+'"><p type="video" src=""><img class="media-canvas thumbnail-img" src="' + thumburl + '"><button class="icon-play"></button></p><div class="image-caption-details"><span class="doc-details">' + filename + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span><span class="doc-thumb">' + thumburl + '</span></div></div>' + caption;
        }
        else if (messageContent.message_type == "location") {
            let Settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');

            longitude = messageContent.location.longitude;
            latitude = messageContent.location.latitude;
            file_url = "https://maps.googleapis.com/maps/api/staticmap?center=" + latitude + "," + longitude + "&zoom=13&size=200x200&markers=color:red|" + latitude + "," + longitude + "&key="+Settings.googleMapKey+"";
            msgcontent = '<a class="receivefrom">' + displayName + '</a><div id="starredmsgcontent-' + messageid + '" class="starredcontent message-location"><a target="_blank" href="https://www.google.com/maps/?q=' + latitude + ',' + longitude + '"><img src="' + file_url + '"></a><span class="loc-latitude">' + latitude + '</span><span class="loc-longitude">' + longitude + '</span></div>';
        }
        else if (messageContent.message_type == "contact") {

            msgcontent = '<a class="receivefrom">' + displayName + '</a><div id="starredmsgcontent-' + messageid + '" class="starredcontent message-contact message-vcard"><div class="contact-body"><div class="avatar-icon"><svg version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve" class=""><g><g><g id="account-circle"> <path d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M255,76.5    c43.35,0,76.5,33.15,76.5,76.5s-33.15,76.5-76.5,76.5c-43.35,0-76.5-33.15-76.5-76.5S211.65,76.5,255,76.5z M255,438.6    c-63.75,0-119.85-33.149-153-81.6c0-51,102-79.05,153-79.05S408,306,408,357C374.85,405.45,318.75,438.6,255,438.6z" data-original="#000000" class="active-path" data-old_color="#000000"/></g> </g></g> </svg></div><div class="document-text"><span class="doc-title cont-name">' + messageContent.contact.name + '</span><span class="cont-number"> ' + module.exports.formatnumber(messageContent.contact.phone_number[0]) + '</span></div></div></div>';
        }
        else if (messageContent.message_type == "audio") {
            filePath = messageContent.media.file_url;
            file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;
            filesize = messageContent.media.file_size;
            duration = messageContent.media.duration;

            msgcontent = '<a class="receivefrom">' + displayName + '</a><div id="starredmsgcontent-' + messageid + '" class="starredcontent message-audio"><div class="bubble-audio-body"><span class="doc-thumb">' + duration + '</span><span class="doc-size">' + filesize + '</span><audio preload="auto"><source type="audio/mpeg" src="' + file_url + '"></audio><div class="audioplayer"> <button class="play pButton"><svg class="playbbt" version="1.1" id="Capa_1" x="0px" y="0px" width="373.008px" height="373.008px" viewBox="0 0 373.008 373.008" style="enable-background:new 0 0 373.008 373.008;" xml:space="preserve"><g><g id="Layer_8_16_"><path d="M61.792,2.588C64.771,0.864,68.105,0,71.444,0c3.33,0,6.663,0.864,9.655,2.588l230.116,167.2c5.963,3.445,9.656,9.823,9.656,16.719c0,6.895-3.683,13.272-9.656,16.713L81.099,370.427c-5.972,3.441-13.334,3.441-19.302,0 c-5.973-3.453-9.66-9.833-9.66-16.724V19.305C52.137,12.413,55.818,6.036,61.792,2.588z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg><svg class="pausebbt" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 535.578 535.578" style="enable-background:new 0 0 535.578 535.578;" xml:space="preserve"> <g><g><g><path d="M231.6,516.278c0,10.658-8.641,19.3-19.3,19.3H106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z"/><path d="M448.728,516.278c0,10.658-8.641,19.3-19.3,19.3h-106.15c-10.659,0-19.3-8.641-19.3-19.3V19.3c0-10.659,8.641-19.3,19.3-19.3h106.15c10.659,0,19.3,8.641,19.3,19.3V516.278z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button><div class="timeline"><div class="playhead"></div><div>' + duration + '</div></div></div><div class="audio-icon"><div class="icon icon-audio-file"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50"><defs><clipPath id="b"><rect width="50" height="50"/></clipPath></defs><g id="a" clip-path="url(#b)"><g transform="translate(1522.452 3497.027)"><path d="M22,1a21.006,21.006,0,0,0-8.174,40.35A21.006,21.006,0,0,0,30.174,2.65,20.868,20.868,0,0,0,22,1m0-1A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z" transform="translate(-1519.452 -3494.054)" fill="#ccc"/><g transform="translate(-1516.606 -3496)"><path d="M0,0H38.307V38.307H0Z" fill="none"/><g transform="translate(10.774 9.577)"><g transform="translate(7.183 24.541)"><path d="M32,59.788c-.552,0-1-.268-1-.6V55.6c0-.331.446-.6,1-.6s1,.268,1,.6V59.19C33,59.521,32.55,59.788,32,59.788Z" transform="translate(-31 -55)" fill="#ccc"/><path d="M32,60.288c-.854,0-1.5-.472-1.5-1.1V55.6c0-.626.644-1.1,1.5-1.1s1.5.472,1.5,1.1V59.19C33.5,59.816,32.852,60.288,32,60.288Zm-.5-1.139a.961.961,0,0,0,1,0v-3.51a.961.961,0,0,0-1,0Z" transform="translate(-31 -55)" fill="#ccc"/></g><g transform="translate(0 16.76)"><path d="M26.38,50.978A8.389,8.389,0,0,1,18,42.6a.6.6,0,0,1,1.2,0,7.183,7.183,0,1,0,14.365,0,.6.6,0,0,1,1.2,0A8.389,8.389,0,0,1,26.38,50.978Z" transform="translate(-18 -42)" fill="#ccc"/><path d="M26.38,51.978A9.39,9.39,0,0,1,17,42.6a1.6,1.6,0,0,1,3.2,0,6.183,6.183,0,1,0,12.365,0,1.6,1.6,0,0,1,3.2,0A9.39,9.39,0,0,1,26.38,51.978Z" transform="translate(-18 -42)" fill="#ccc"/></g><path d="M30.183,29.168a.6.6,0,1,1,0-1.2h3.591V25.577H30.183a.6.6,0,0,1,0-1.2h3.591V21.986H30.183a.6.6,0,0,1,0-1.2h3.556a5.386,5.386,0,0,0-10.739.6V32.76a5.387,5.387,0,1,0,10.774,0V29.168Z" transform="translate(-20.007 -16)" fill="#ff6b19"/></g></g></g></g></svg></div></div></div></div>';

            indexDb.blobImageConversion(file_url,'#starredmsgcontent-' + messageid + ' source',messageid,'chatAudios');

        }
        else if (messageContent.message_type == "file") {
            filePath = messageContent.media.file_url;
            filename = messageContent.media.file_name;
            file_url = messageContent.media.file_url;
            msgtype = file_url.substr((file_url.lastIndexOf('.') + 1));
            filesize = messageContent.media.file_size;
            
            let typeimage =  module.exports.getfavFileTypeImg(msgtype);

            
            contentdiv = '<div id="starredcontent-' + messageid + '" class="starredcontent message-doc reply-doc"><a class="document-container" title="' + filename + '" download="' + filename + '"  href="javascript:void();">';
            contentdiv = contentdiv + '<div class="document-body"><p class="receivefrom">' + displayName + '</p><div class="document-info"><div class="document-icon"><div class="ic-doc ' + typeimage + '"></div></div>';
            contentdiv = contentdiv + '<div class="document-text"><span class="doc-title">' + filename + '</span>';
            contentdiv = contentdiv + '</div>';
            contentdiv = contentdiv + '</div></div></a><div class="document-details">';
            msgcontent = contentdiv + '<span class="doc-details">' + msgtype + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span></div>';
        }
        return [messageContent.message_type, msgcontent, filePath,textmsg];
    },
    sendreplymessage: function (messageContent, messageid, Profile) {
        let mediaUrl = window._env_.ApiURL + "/media/";
        let userToken = storage.getuserToken();
        let text_length,textmsg,msgcontent,file_url,filename,filesize,duration,msgtype;
        if (messageContent.message_type == "text" || messageContent.message_type == "auto_text") {

            text_length = messageContent.message.length;
            if (text_length <= 250) {

                textmsg = messageContent.message;
            } else {
                textmsg = messageContent.message.substring(0, 250) + "....";

            }
            msgcontent = '<div class="replycontent statictext replaymsg"><a class="receivefrom">' + Profile + '</a>' + textmsg + '</div><i class="replyclose"></i>';
        } else if (messageContent.message_type == "video") {
            msgcontent = '<div  class="replycontent reply-message-img"><div class="imagereply"><a class="receivefrom">' + Profile + '</a><div class="image-info"> <i class="video-file text-italic"></i><span class="name-status">Video</span></div></div><div class="message-img media-canvas-component"></p></div></div> <i class="replyclose"></i>';
        } else if (messageContent.message_type == "image") {
            file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;
            indexDb.blobImageConversion(file_url,'#sendReplyImage-' + messageid +'',messageid,'chatImages');

            msgcontent = '<div  class="replycontent reply-message-img"><div class="imagereply"><a class="receivefrom">' + Profile + '</a><div class="image-info"> <i class="cam-ico text-italic"></i><span class="name-status">Photo</span></div></div><div class="message-img media-canvas-component"><p id="sendReplyImage-' + messageid + '" class="media-canvas thumbnail-img" type="image" src="' + file_url + '" style="background-image:url(' + file_url + ')"></p></div></div><i class="replyclose"></i>';
        } else if (messageContent.message_type == "audio") {
            duration = messageContent.media.duration;
            msgcontent = '<div  class="replycontent reply-message-audio"><a class="receivefrom">' + Profile + '</a><div class="reply-audio"><div class="audio-icon"><div class="icon icon-audio-file"><svg version="1.1" id="Capa_1"  x="0px" y="0px" width="287.386px" height="287.386px" viewBox="0 0 287.386 287.386" style="enable-background:new 0 0 287.386 287.386;" xml:space="preserve"><g><g><path d="M62.743,155.437v98.42c0,5.867,4.741,10.605,10.605,10.605c5.854,0,10.605-4.738,10.605-10.605v-98.42c0-5.856-4.751-10.605-10.605-10.605C67.484,144.832,62.743,149.576,62.743,155.437z"/><path d="M29.456,264.582h23.351v-116.85c0.064-0.56,0.166-1.119,0.166-1.693c0-50.412,40.69-91.42,90.698-91.42c50.002,0,90.692,41.008,90.692,91.42c0,0.771,0.113,1.518,0.228,2.263v116.28h23.354c16.254,0,29.442-13.64,29.442-30.469v-60.936c0-13.878-8.989-25.57-21.261-29.249c-1.129-66.971-55.608-121.124-122.45-121.124 c-66.86,0-121.347,54.158-122.465,121.15C8.956,147.638,0,159.32,0,173.187v60.926C0,250.932,13.187,264.582,29.456,264.582z"/><path d="M203.454,155.437v98.42c0,5.867,4.748,10.605,10.604,10.605s10.604-4.738,10.604-10.605v-98.42c0-5.856-4.748-10.605-10.604-10.605C208.191,144.832,203.454,149.576,203.454,155.437z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div></div><div class="audio-info">' + duration + '<span>audio</span></div></div></div><i class="replyclose"></i>';
        } else if (messageContent.message_type == "file") {
            filename = messageContent.media.file_name;
            file_url = messageContent.media.file_url;
            msgtype = file_url.substr((file_url.lastIndexOf('.') + 1));
            filesize = messageContent.media.file_size;
            let typeimage;
            if (msgtype == 'pdf' || msgtype == 'PDF') {
                typeimage = 'icon-doc-pdf';
            } else {
                typeimage = 'icon-doc-dox';
            }
            msgcontent = '<div class="replycontent message-doc reply-doc"><a class="document-container" title="' + filename + '"  download="' + filename + '" href="javascript:void();"><div class="document-body"><p class="receivefrom">' + Profile + '</p><div class="document-info"><div class="document-icon"><div class="ic-doc ' + typeimage + '"></div></div><div class="document-text"><span class="doc-title">' + filename + '</span></div></div></div></a><div class="document-details"><span class="doc-details">' + msgtype + '</span><span class="doc-size">' + module.exports.bytesToSize(filesize) + '</span></div></div><i class="replyclose"></i>';
        } else if (messageContent.message_type == "contact") {
            msgcontent = '<div class="replycontent"><div class="mainavatar-info"><a class="receivefrom">' + Profile + '</a><div class="avatar-info"><div class="avatar-ic"></div><div class="document-text"><span class="doc-title cont-name">' + messageContent.contact.name + '</span></div></div></div></div><i class="replyclose"></i>';
        } else if (messageContent.message_type == "location") {
            let Settings = webEncrypt.getFromLocalStorageAndDecrypt('settings');

            msgcontent = '<div  class="replycontent location-reply"><div class="location-reply-info"><a class="receivefrom">' + Profile + '</a><div class="location-info"><i class="loc-ic"></i>location</div></div><div class="location-map"><a target="_blank" href="https://www.google.com/maps/?q=13.0154998,80.2004422"><img src="https://maps.googleapis.com/maps/api/staticmap?center=13.0154998,80.2004422&amp;zoom=13&amp;size=200x200&amp;markers=color:red|13.0154998,80.2004422&amp;key='+Settings.googleMapKey+'"></a></div></div><i class="replyclose"></i>';
        }
        return [messageContent.message_type, msgcontent];
    },
    getMediaurls: function (messageContent, messageid) {
        let mediaUrl = window._env_.ApiURL + "/media/";
        let userToken = storage.getuserToken();
        let thumb,file_url,thumburl,msgcontent,duration,msgtype;
        if (messageContent.message_type == "video") {

            thumb = messageContent.media.thumb_image;
            thumburl = 'data:image/png;base64,' + thumb;
            msgcontent = '<div class="media-canvas-component initial" id="media-' + messageid + '" data-media-file="'+messageContent.media.file_url+'"><p type="video" src="" ><img class="media-canvas thumbnail-img" src="' + thumburl + '" data-msg-id="'+messageid+'"><i class="video-file-light"></i></img></p></div>';
        } else if (messageContent.message_type == "image") {

            file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;
            indexDb.blobImageConversion(file_url,'#mediaImg-' + messageid +'',messageid,'chatImages');

            msgcontent = '<div class="media-canvas-component initial" id="media-' + messageid + '"><p id="mediaImg-' + messageid + '" class="media-canvas thumbnail-img" type="image"  src="' + file_url + '" style="background-image:url(' + file_url + ')" data-msg-id="'+messageid+'"></p></div>';
        } else if (messageContent.message_type == "audio") {

            file_url = mediaUrl + messageContent.media.file_url + "?mf=" + userToken;
            duration = messageContent.media.duration;
            indexDb.blobImageConversion(file_url,'#mediaAudioList-'+messageid+'',messageid,'chatAudios');

            msgcontent = '<div class="media-canvas-component initial" id="media-' + messageid + '"><p id="mediaAudioList-' + messageid + '" class="media-canvas thumbnail-audio" type="audio" length="' + duration + '" src="' + file_url + '" data-msg-id="'+messageid+'"></p></div>';
        } else if (messageContent.message_type == "file") {

            file_url = messageContent.media.file_url;
            msgtype = messageContent.media.caption;
            let typeimage;
            if (msgtype == 'pdf' || msgtype == 'PDF') {
                typeimage = 'thumbnail-pdf';
            } else if (msgtype == "xls" || msgtype == 'xlsx') {
                typeimage = 'thumbnail-xls';
            } else if (msgtype == "txt") {
                typeimage = 'thumbnail-txt';
            } else {
                typeimage = 'thumbnail-dox';
            }
            msgcontent = '<div class="media-canvas-component initial" id="media-' + messageid + '"><p class="media-canvas ' + typeimage + '" type="file"  src="' + mediaUrl + file_url + '?mf=' + userToken + '" data-msg-id="'+messageid+'"></p></div>';
        }
        return msgcontent;
    },
    bytesToSize: function (bytes) {
        let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        let totalBytes = bytes / Math.pow(1024, i);
        return Math.round(totalBytes) + ' ' + sizes[i];
    },
    formatnumber: function (name) {
        if (name.isNumber()) {
            try {
                const number = phoneUtil.parseAndKeepRawInput('+' + name, '');
                let newName = phoneUtil.format(number, PNF.INTERNATIONAL);
                name = newName;
            }
            catch (e) {
                console.log("invalid number format");
            }
        }
        return name;
    },
    StripTags: function (dirtyString) {

        let container = document.createElement('div');
        let text = document.createTextNode(dirtyString);
        container.appendChild(text);
        return container.innerHTML; // innerHTML will be a xss safe string

    },
    getFirstMsgContent(userInfo,nodeJid,nodeJidName,userid){
        let nodeName,msgContent;
        if (userInfo != null && typeof userInfo[nodeJid] != "undefined") {
            nodeName = userInfo[nodeJid][1];
            msgContent = nodeName + " created this team";
        } else {
            if (nodeJid == userid) {
                msgContent = "You created this team";
            } else {
                msgContent = nodeJidName + " created this team";
            }
        }

        return msgContent;
    },
    getSecondSplitMsgContent: function(nodeJid,userid,addJid,msgConvFrom,msgConvTo){
        let msgContent;
        if (nodeJid == userid) {
            msgContent = "You added";
        } else {
            msgContent = msgConvFrom + " added";
        }
        if (addJid == userid) {
            if (nodeJid != userid) {
                msgContent = msgContent + " you";

                $('#comment').prop('disabled', false);
            } else {
                msgContent = '';
            }
        } else {
            msgContent = msgContent + " " + msgConvTo;
        }

        return msgContent;
    },
    getThirdSplitMsgContentFirst: function(nodeJid,userid,msgContent,adminUserName){
        let msg;
        if (nodeJid == userid) {
            msg = msgContent + " left";
        } else {
            if(nodeJid == adminUserName){
                let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
                msgContent = (userInfo != null && typeof(userInfo[nodeJid]) != 'undefined')  ? userInfo[nodeJid][1] : '';
            }
            msg = "You were removed from the team by " + msgContent;
        }

        return msg;
    },
    getThirdSplitMsgContentSecond: function(nodeJid,msgConvTo,msgContent,adminUserName){
        let msg;
        if(nodeJid == adminUserName){
            msg = msgConvTo + " removed from the team by Switchboard";

        }else {

            msg = msgConvTo + " removed from the team by " + msgContent;
        }

        return msg;
    },
    getThirdSplitMsgContent: function(nodeJid,userid,addJid,msgConvFrom,msgConvTo){
        let msgContent;
        let adminUserName = storage.adminName();
        if (nodeJid == userid) {
            msgContent = "You ";
        } else {
            msgContent = msgConvFrom;
        }
        if (addJid == userid) {
            msgContent = module.exports.getThirdSplitMsgContentFirst(nodeJid,userid,msgContent,adminUserName);
            
        } else {
            if (nodeJid == userid) {
                msgContent = msgConvTo + " removed from the team by " + msgContent;
            } else {
                if (addJid == nodeJid) {

                    msgContent = msgContent + " left";

                } else {
                    msgContent = module.exports.getThirdSplitMsgContentSecond(nodeJid,msgConvTo,msgContent,adminUserName);

                   
                }
            }
        }

        return msgContent;
    },
    getForthSplitMsgContent: function(nodeJid,userid,msgConvFrom) {
        let msgContent;
        if (nodeJid == userid) {
            msgContent = "You updated this team profile";
        } else {
            msgContent = msgConvFrom + " updated this team profile";
        }

        return msgContent;
    },
    getFifthSplitMsgContent(addJid,userid,msgConvTo){
        let msgContent,msgTo;
        if (addJid == userid) {
            msgContent = "You are now Admin";
        } else {
            msgTo = msgConvTo;
            msgContent = msgTo + " is now Admin";
        }

        return msgContent;
    },
    groupstatus: function (from, nodeJid, addJid, status, msgConvFrom, msgConvTo) {
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');
        
        let userid = stropheConnection.logininfo.userJID;
        let nodeJidName = nodeJid;
        
        let groupParticipantNames = {};
        let groupmember,msgContent;
        let toJID = webEncrypt.getFromLocalStorageAndDecrypt('toJID')
        if (toJID != null && toJID != "") {
            groupmember = groupDetail != null ? (groupDetail[from]) : '';
            for (let keys in groupmember) {
                let values = groupmember[keys];
                groupParticipantNames[values.user] = values.displayName;
            }
        }
        if (status == 1) {
            msgContent = module.exports.getFirstMsgContent(userInfo,nodeJid,nodeJidName,userid)
           
        } else if (status == 2) {
            msgContent = module.exports.getSecondSplitMsgContent(nodeJid,userid,addJid,msgConvFrom,msgConvTo)
            
        } else if (status == 3) {
            msgContent = module.exports.getThirdSplitMsgContent(nodeJid,userid,addJid,msgConvFrom,msgConvTo)
            
        } else if (status == 4) {
            msgContent = module.exports.getForthSplitMsgContent(nodeJid,userid,msgConvFrom)
           
        } else if (status == 5) {
            msgContent = module.exports.getFifthSplitMsgContent(addJid,userid,msgConvTo)
        }
        return msgContent;
    },

    broadcastNotificationLablestatus( status, msgConvTo){
        let msgContent;

        if (status == 0) { // Broadcast Created Lable Status update
            msgContent = module.exports.broadcastCreatedStatusContent()
           
        }else if(status == 1){ // Broadcast Profile Update Lable Status update
            msgContent = module.exports.broadcastProfileUpdateStatusContent()

        }else if(status == 2){// Add Broadcast Member Lable Status update
            msgContent = module.exports.addBroadcastMemberStatus(msgConvTo)

        }else if(status == 3){// Remove Broadcast Lable Status update
            msgContent = module.exports.removeBroadcastMemberStatus(msgConvTo)

        }

        return msgContent;
    },

    broadcastCreatedStatusContent: function(){
        let messageContent = "Broadcast Created";

        return messageContent;
    },

    broadcastProfileUpdateStatusContent: function(){
        let messageContent = "You updated this broadcast profile";

        return messageContent;
    },
    removeBroadcastMemberStatus: function(msgConvTo){

        let messageContent = msgConvTo + " removed";

        return messageContent;
    },
    addBroadcastMemberStatus(msgConvTo){
        let messageContent = msgConvTo + " added";

        return messageContent;
    },

    determineDropDirection: function () {
        $(".dropdown-menu").each(function () {
            // Invisibly expand the dropdown menu so its true height can be calculated
            $(this).css({
                visibility: "hidden",
                display: "block"
            });
            // Necessary to remove class each time so we don't unwantedly use dropup's offset top
            $(this).parent().removeClass("dropup");
            // Determine whether bottom of menu will be below window at current scroll position
            if ($(this).offset().top + $(this).outerHeight() > $(window).innerHeight() + $(window).scrollTop()) {
                $(this).parent().addClass("dropup");
            }
            // Return dropdown menu to fully hidden state
            $(this).removeAttr("style");
        });
    },
    updateemojiclick: function (inputname) {
        $(".wrap").find('em').click(function (e) {
            e.stopPropagation();
            $("#send-icon").css("display", "block");
            $("#microphone").css("display", "none");
            let emojiShortcode = $(e.target).parent().find('.emoji').attr('class').split('emoji-')[1];
            let emojiUnicode = module.exports.toUnicode(module.exports.findEmoji(emojiShortcode).unicode.apple);
            module.exports.insertAtCaret(document.getElementById(inputname), emojiUnicode, inputname);
        });
        $('.emojiPicker').find('nav .tab').removeClass('active');
        $('.emojiPicker').find('nav .tab[data-tab=recent]').addClass('active');


        $(".emojiPicker").find('.sections').scroll(function (e) {
            let sections = $('section');
            $.each(sections, function (key, value) {
                let section = sections[key];
                let offsetFromTop = $(section).position().top;
                if (section.className == 'search' || (section.className == 'people' && offsetFromTop > 0)) {
                    $(section).parents('.emojiPicker').find('nav tab.recent').addClass('active');
                    return;
                }
                if (offsetFromTop <= 0) {
                    $(section).parents('.emojiPicker').find('nav .tab').removeClass('active');
                    $(section).parents('.emojiPicker').find('nav .tab[data-tab=' + section.className + ']').addClass('active');
                }
            });
        }); // Enable scroll event
        $(".emojiPicker").find('nav .tab').click(function (e) {
            e.stopPropagation();
            let section = '';
            let $section;
            // Update tab
            $(".emojiPicker").find('nav .tab').removeClass('active');
            if ($(e.target).parent().hasClass('tab')) {
                section = $(e.target).parent().attr('data-tab');
                $(e.target).parent('.tab').addClass('active');
            } else {
                section = $(e.target).attr('data-tab');
                $(e.target).addClass('active');
            }
            $section = module.exports.sectionElReturn(section);

            let heightOfSectionsHidden = $section.parent().scrollTop();
            let heightOfSectionToPageTop = $section.offset().top;
            let heightOfSectionsToPageTop = $section.parent().offset().top;
            let scrollDistance = heightOfSectionsHidden + heightOfSectionToPageTop - heightOfSectionsToPageTop + 30;
            $('.sections').off('scroll'); // Disable scroll event until animation finishes
            $('.sections').animate({
                scrollTop: scrollDistance
            }, 250, function () {
                $(".emojiPicker").find('.sections').scroll(function (e) {
                    let sections = $('section');
                    $.each(sections, function (key, value) {
                        let section = sections[key];
                        let offsetFromTop = $(section).position().top;
                        if (section.className == 'search' || (section.className == 'people' && offsetFromTop > 0)) {
                            $(section).parents('.emojiPicker').find('nav tab.recent').addClass('active');
                            return;
                        }
                        if (offsetFromTop <= 0) {
                            $(section).parents('.emojiPicker').find('nav .tab').removeClass('active');
                            $(section).parents('.emojiPicker').find('nav .tab[data-tab=' + section.className + ']').addClass('active');
                        }
                    });
                }); // Enable scroll event
            });
        });
    },
    sectionElReturn: function (section){
        let $section;
        if ($("#messageemoji").css('display') == 'block') {
            $section = $("#messageemoji").find(".emojiPicker").find('section.' + section);
        } else if ($("#groupemoji").css('display') == 'block') {
            $section = $("#groupemoji").find(".emojiPicker").find('section.' + section);
        }
        else if ($("#profileemoji").css('display') == 'block') {
            $section = $("#profileemoji").find(".emojiPicker").find('section.' + section);
        }
        else if ($("#statusemoji").css('display') == 'block') {
            $section = $("#statusemoji").find(".emojiPicker").find('section.' + section);
        }
        else if ($("#groupupdateemoji").css('display') == 'block') {
            $section = $("#groupupdateemoji").find(".emojiPicker").find('section.' + section);
        } else {
            $section = $(".emojiPicker").find('section.' + section);
        }

        return $section;
    },
    findEmoji: function (emojiShortcode) {
        let emojis = $.fn.emojiPicker.emojis;
        for (let value of emojis){
            if (value.shortcode == emojiShortcode) {
                return value;
            }
        }
    },
    emojiInsertAtInternetExplorer: function(inputField, myValue, inputname){
        let EmojiLength,sel,Maxlength,Contentlength;

        inputField.focus();
        sel = document.selection.createRange();
        Maxlength = $('#' + inputname).attr("maxlength");
        Contentlength = (sel.text).length;
        EmojiLength = myValue.length;
        if (typeof Maxlength == "undefined" || Maxlength >= (Contentlength + EmojiLength)) {
            sel.text = myValue;
            inputField.focus();
            $('#' + inputname).trigger("input");
        }
    },
    insertAtCaret: function (inputField, myValue, inputname) {
        let EmojiLength,Maxlength,Contentlength,startPos,endPos,scrollTop;
        if (inputname == "comment") {
            Position = storage.getCommentPosition();
            EmojiLength = myValue.length;
            inputField.innerHTML = inputField.innerHTML.substring(0, Position) + myValue + inputField.innerHTML.substring(Position, inputField.innerHTML.length);
            module.exports.setposition(Position + EmojiLength);
            storage.setCommentPosition(Position + EmojiLength);
        } else {
            if (document.selection) {
                //For browsers like Internet Explorer
                module.exports.emojiInsertAtInternetExplorer(inputField, myValue, inputname);
                
            } else if (inputField.selectionStart || inputField.selectionStart == '0') {
                //For browsers like Firefox and Webkit based
                startPos = inputField.selectionStart;
                endPos = inputField.selectionEnd;
                scrollTop = inputField.scrollTop;
                Maxlength = $('#' + inputname).attr("maxlength");
                Contentlength = (inputField.value).length;
                EmojiLength = myValue.length;
                if (typeof Maxlength == "undefined" || Maxlength >= (Contentlength + EmojiLength)) {
                    inputField.value = inputField.value.substring(0, startPos) + myValue + inputField.value.substring(endPos, inputField.value.length);
                    inputField.focus();
                    inputField.selectionStart = startPos + myValue.length;
                    inputField.selectionEnd = startPos + myValue.length;
                    inputField.scrollTop = scrollTop;
                    $('#' + inputname).trigger("input");
                }
            } else {
                inputField.focus();
                Maxlength = $('#' + inputname).attr("maxlength");
                Contentlength = (inputField.value).length;
                EmojiLength = myValue.length;
                if (typeof Maxlength == "undefined" || Maxlength >= (Contentlength + EmojiLength)) {
                    inputField.value += myValue;
                    $('#' + inputname).trigger("input");
                }
            }
        }
    },
    toUnicode: function (code) {
        let codes = code.split('-').map(function (value, index) {
            return parseInt(value, 16);
        });
        return String.fromCodePoint.apply(null, codes);
    },
    encrypt: function (newmsgcontent, msgid) {
        if(typeof msgid != "undefined") {
            let key = CryptLib.getHashSha256(msgid, 32);
            let Encryptbody = CryptLib.encrypt(encodeURIComponent(newmsgcontent), key, iv);
            return Encryptbody;
        } else {
            return "";
        }
    },
    decrypt: function (oldmsgcontent, messagegid) {
        if (typeof messagegid != "undefined") {
            try {
                let key = CryptLib.getHashSha256(messagegid, 32);
                let Decryptbody = CryptLib.decrypt(oldmsgcontent, key, iv);
                let OriginalMsgBody = Decryptbody.replace(/\+/g, "%20");
                return decodeURIComponent(OriginalMsgBody);
            } catch (e) {
                // If decryption fails, return an empty string
                return "";
            }
        } else {
            return "";
        }
    },    
    todayDate: function () {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        today = dd + '-' + mm + '-' + yyyy;
        return today;
    },
    setposition: function (pos) {
        let el = document.getElementById("comment");
        let range = document.createRange();
        let sel = window.getSelection();
        range.setStart(el.childNodes[0], pos);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        el.focus();
    },
    getCaretCharacterOffsetWithin: function (element) {
        let caretOffset = 0;
        let doc = element.ownerDocument || element.document;
        let win = doc.defaultView || doc.parentWindow;
        let sel;
        if (typeof win.getSelection != "undefined") {
            sel = win.getSelection();
            if (sel.rangeCount > 0) {
                let range = win.getSelection().getRangeAt(0);
                let preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(element);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                caretOffset = preCaretRange.toString().length;
            }
        } else if ((sel == doc.selection) && (typeof sel != 'undefined' && sel.type != "Control") ) {
            let textRange = sel.createRange();
            let preCaretTextRange = doc.body.createTextRange();
            preCaretTextRange.moveToElementText(element);
            preCaretTextRange.setEndPoint("EndToEnd", textRange);
            caretOffset = preCaretTextRange.text.length;
        }
        return caretOffset;
    },
    // function used to convert hex value to RGBA
    hexToRgbA: function(hex) {
        let c;
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
    },
    // function used to get the name of the status on giving id
    getStatusName: function(statusId) {
        let profileStatus = webEncrypt.getFromLocalStorageAndDecrypt('profileStatus');
        return ((typeof profileStatus[statusId] == "undefined")) ? "" : profileStatus[statusId].name;
    },

    // function used to get the image of the status on giving id
    getStatusImage: function(statusId) {
        let profileStatus = webEncrypt.getFromLocalStorageAndDecrypt('profileStatus');
        return ((typeof profileStatus[statusId] == "undefined")) ? "" : profileStatus[statusId].image;
    },

    // function used to get the check whether status is empty on updating profile
    checkStatus: function() {
        let myInfo = webEncrypt.getFromLocalStorageAndDecrypt('myInfo');
        if(module.exports.getStatusName(myInfo[stropheConnection.logininfo.userJID][3]) == "") {
            $("#infoContent").text("Your status cannot be empty. Kindly update status first.");
            $('#infobox').css("display", "block").delay(4000).fadeOut();
            return false;
        } else {
            return true;
        }
    },

    // function to acknowledge the count of priority message
    priorityMessageAcknowledged(toJID, messageId) {
        
        let usersPriorityInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersPriorityInfo');

        if(usersPriorityInfo != null && typeof(usersPriorityInfo[toJID]) != "undefined") {
            let decrementCount = parseInt(usersPriorityInfo[toJID][1]) - 1;

            if(decrementCount == 0) {
                delete usersPriorityInfo[toJID];
                $("#"+toJID).find(".priority-message-recent").remove();
                $("#conversation"+toJID).find(".priority-message-conversation").remove();
            } else if (decrementCount == 1) {
                $("#conversation"+toJID).find(".priority-message-conversation").html("PRIORITY: You have a Priority Message");
                usersPriorityInfo[toJID][1] = decrementCount;
            } else {
                $("#conversation"+toJID).find(".priority-message-conversation").html("PRIORITY: You have <span class='priority-count'>" + decrementCount + "</span> Priority Messages");
                usersPriorityInfo[toJID][1] = decrementCount;
            }
            webEncrypt.encryptAndStoreInLocalStorage('usersPriorityInfo', usersPriorityInfo);        
            
        }
        
        $('<li role="presentation"><a  class="deletesingle" >' + language.locali().delete + '</a></li>').insertAfter($("#chat-" + messageId).find(".dropdown-menu li:eq(0)"));

        let priorityMessages = webEncrypt.getFromLocalStorageAndDecrypt('priorityMessages');
        priorityMessages = $.grep(priorityMessages, function(e){ 
            return e != messageId; 
        });
        webEncrypt.encryptAndStoreInLocalStorage('priorityMessages', priorityMessages)
    },
    // check whether participant of group or he is blocked
    checkBlockedOrNotInGroup: function (toJID) {
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let groupDetail = webEncrypt.getFromLocalStorageAndDecrypt('groupDetails');
        let blockUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockUserInfo');


        if (groupInfo != null && typeof groupInfo[toJID] != "undefined") {
            let groupMember = groupDetail[toJID];
            for (let keys in groupMember) {
                let values = groupMember[keys];
                let itemvalue = values.user;
                if(itemvalue == stropheConnection.logininfo.userJID) {
                    return true;
                }
            }
        } else if (userInfo != null && typeof userInfo[toJID] != "undefined" && blockUserInfo != null && typeof blockUserInfo[toJID] == "undefined") {
            return true;
        }
        return false;
    },

    // function used to get the abbreviation of the site on giving id
    getSiteAbbreviation: function(siteId) {
        let siteDetails = webEncrypt.getFromLocalStorageAndDecrypt('siteDetails');
        return ((typeof siteDetails[siteId] == "undefined")) ? "" : siteDetails[siteId].abbreviation;
    },

    // function used to get the name of the site on giving id
    getSiteName: function(siteId) {
        let siteDetails = webEncrypt.getFromLocalStorageAndDecrypt('siteDetails');
        return ((typeof siteDetails[siteId] == "undefined")) ? "" : siteDetails[siteId].name;
    },

    // function used to frame info line of users
    frameUserRoleDept: function(role, department, site) {
        let infoLine;
        if (role != "" && department != "" && site != "") {
            infoLine = role + ', ' + department + ", " + site;
        } else if (role == "" && department != "" && site != "") {
            infoLine = department + ", " + site;
        } else if (role == "" && department == "" && site != "") {
            infoLine = site;
        } else if (role != "" && department == "" && site != "") {
            infoLine = role + ", " + site;
        } else if (role != "" && department == "" && site == "") {
            infoLine = role;
        } else if (role != "" && department != "" && site == "") {
            infoLine = role + ", " + department;
        } else {
            infoLine = "";
        }
        return infoLine;

    },

    //function used to update network address
    updateNetworkAddress: function() {
        let ip = "";
        resourceIpUpdate.updateNetworkAddress(ip); // Update Network address with empty IP
    },

    // function used to close all the popups during logging out
    closePopups: function() {
        $(".cam-close").trigger("click");
        $("#camerapic .close").trigger("click");
        $("#auth-failed").trigger('click');
        $("#logout-contact .mute-bts .cancel").trigger('click');
        $("#unblock-contact .mute-bts .cancel").trigger('click');
        $("#block-contact .mute-bts .cancel").trigger('click');
        $("#exit-group .mute-bts .cancel").trigger('click');
        $(".ack-popup").removeClass("view");
        $("#acknowledge-msg").removeClass("open");
        $("#accept-msg").removeClass("open");
        $("#reject-msg").removeClass("open");
        $("#add-participant").removeClass("open");
        $("#forward-msg").removeClass("open");
    },

    // function to make a person active or inactive in oncall
    changeOncallStatus: function(userId, userStatus) {
        if ($("#roster-" + userId).length) {
            if(userStatus == 0) {
                $("#roster-" + userId).find(".oncall-contact").remove();
            } else if (userStatus == 1) {
                $("#roster-" + userId).find(".dept-div").append('<span class="oncall-contact name-status pull-right" id="oncall-'+nodeJid+'"><img class="low-priority-arrow rollicon" src="./src/images/rollicon.svg"/><span class="oncall-contact-text">On Call</span></span>');
            }
        }
        
        if($("#recentchatcontent").find("#"+userId)) {
            if(userStatus == "0") {
                $("#recentchatcontent").find("#"+userId).find(".oncall-recent").remove();
            } else if (userStatus == "1") {
                $("#recentchatcontent").find("#"+userId).find(".time-msg-block").append('<span class="oncall-recent"><img class="low-priority-arrow rollicon" src="./src/images/rollicon.svg"/><span class="oncall-recent-text">On Call</span></span>')
                
            }
        }
    },

    // function to set selection details of site
    setSiteSelectionDetails: function(contactsType, contactsSite, rolesType, rolesSite,participantType, participantSite) {
        let sites = JSON.parse(localStorage.getItem("selectedSitesInfo"));
        if(typeof sites == "undefined" || sites == null) 
            sites = {};
        if(contactsType != "") {
            sites.contactsSelectedSites = contactsSite;
        } else if (rolesType != "") {
            sites.rolesSiteType = rolesType;
            sites.rolesSelectedSites = rolesSite;
        }else if(participantType != ""){
            sites.participantSelectedSite = participantSite;

        }
        localStorage.setItem("selectedSitesInfo", JSON.stringify(sites));
    },

    getOncallIcon: function(onCallIcon, fillColor, onCallImage) {
        let Icon;
        switch (onCallIcon) {
            case 'Ambulance':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26848" data-name="Group 26848" transform="translate(-9318 -11373)">\n' +
                    '    <g id="Group_26842" data-name="Group 26842">\n' +
                    '      <circle id="Ellipse_254" data-name="Ellipse 254" cx="75" cy="75" r="75" transform="translate(9318 11373)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '      <path id="ambulance" d="M49.471,177.472a4.948,4.948,0,1,1,1.449,3.5A4.767,4.767,0,0,1,49.471,177.472Zm14.841-19.789H49.471v-9.894h6.107a1.607,1.607,0,0,1,.85.348l7.537,7.537a2.823,2.823,0,0,1,.348.85ZM14.841,177.472a4.948,4.948,0,0,1,4.947-4.947,4.947,4.947,0,1,1-3.5,8.445A4.766,4.766,0,0,1,14.841,177.472ZM9.894,151.5v-7.421a1.191,1.191,0,0,1,1.237-1.237h8.657v-8.658a1.191,1.191,0,0,1,1.237-1.237h7.421a1.191,1.191,0,0,1,1.237,1.237v8.658H38.34a1.191,1.191,0,0,1,1.237,1.237V151.5a1.191,1.191,0,0,1-1.237,1.237H29.683v8.657a1.191,1.191,0,0,1-1.237,1.237H21.025a1.191,1.191,0,0,1-1.237-1.237v-8.657H11.131A1.191,1.191,0,0,1,9.894,151.5ZM0,130.474V175a2.377,2.377,0,0,0,.734,1.739,2.377,2.377,0,0,0,1.739.734H9.894a9.533,9.533,0,0,0,2.9,7,9.533,9.533,0,0,0,7,2.9,9.533,9.533,0,0,0,7-2.9,9.533,9.533,0,0,0,2.9-7H44.524a9.893,9.893,0,0,0,16.89,7,9.533,9.533,0,0,0,2.9-7H69.26a2.474,2.474,0,0,0,0-4.947V156.446a6.027,6.027,0,0,0-.5-2.242,5.876,5.876,0,0,0-1.237-1.971l-7.653-7.653a5.875,5.875,0,0,0-1.971-1.237,6.026,6.026,0,0,0-2.242-.5H49.471V130.474A2.508,2.508,0,0,0,47,128H2.474a2.377,2.377,0,0,0-1.739.734A2.377,2.377,0,0,0,0,130.474Z" transform="translate(9357 11290)"    fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>'
                break;
            case "Group":
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26856" data-name="Group 26856" transform="translate(-9312 -11567)">\n' +
                    '    <circle id="Ellipse_254" data-name="Ellipse 254" cx="75" cy="75" r="75" transform="translate(9312 11567)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="group_12_" data-name="group (12)" transform="translate(9343 11612.5)">\n' +
                    '      <circle id="Ellipse_260" data-name="Ellipse 260" cx="7.304" cy="7.304" r="7.304" transform="translate(7.304 11.978)"    fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_20434" data-name="Path 20434" d="M24.357,14.461a15.3,15.3,0,0,0-6.1,12.234v.913H2.739A2.759,2.759,0,0,1,0,24.868V23.042A10.037,10.037,0,0,1,10.042,13h9.129A9.977,9.977,0,0,1,24.357,14.461Z" transform="translate(0 17.237)"    fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <circle id="Ellipse_261" data-name="Ellipse 261" cx="7.304" cy="7.304" r="7.304" transform="translate(65.732 11.978)"     fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_20435" data-name="Path 20435" d="M41.687,23.042v1.826a2.759,2.759,0,0,1-2.739,2.739H23.429v-.913a15.3,15.3,0,0,0-6.1-12.234A9.977,9.977,0,0,1,22.516,13h9.129A10.037,10.037,0,0,1,41.687,23.042Z" transform="translate(45.956 17.237)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <circle id="Ellipse_262" data-name="Ellipse 262" cx="10.279" cy="10.279" r="10.279" transform="translate(33.065 6.5)" fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_20436" data-name="Path 20436" d="M36.627,14H16.542A10.051,10.051,0,0,0,6.5,24.042V29.52a2.74,2.74,0,0,0,2.739,2.739H43.931A2.74,2.74,0,0,0,46.67,29.52V24.042A10.051,10.051,0,0,0,36.627,14Z" transform="translate(17.237 19.888)" fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Role':
                Icon =  '<svg class="svg-code-roles" xmlns="http://www.w3.org/2000/svg" width="24px" height="51px" viewBox="0 0 12.195 10.085">\n' +
                    '  <g id="Group_27174" data-name="Group 27174" transform="translate(0.15 0.15)">\n' +
                    '    <g id="Id_Card" data-name="Id Card" transform="translate(0 0)">\n' +
                    '      <path id="Path_10935" data-name="Path 10935" d="M11.147,23.379H.747A.75.75,0,0,1,0,22.63V16.147A.747.747,0,0,1,.747,15.4H4.512a.18.18,0,0,1,0,.361H.747a.386.386,0,0,0-.387.387V22.63a.387.387,0,0,0,.387.387h10.4a.387.387,0,0,0,.387-.387V16.147a.386.386,0,0,0-.387-.387H7.564a.18.18,0,0,1,0-.361h3.583a.747.747,0,0,1,.747.747V22.63A.749.749,0,0,1,11.147,23.379Z" transform="translate(0 -13.594)" fill="'+module.exports.hexToRgbA(fillColor)+'" stroke="'+module.exports.hexToRgbA(fillColor)+'" stroke-width="0.3"/>\n' +
                    '      <path id="Path_10937" data-name="Path 10937" d="M9.127,26.377a1.084,1.084,0,1,1,1.084-1.084A1.085,1.085,0,0,1,9.127,26.377Zm0-1.808a.723.723,0,1,0,.723.723A.724.724,0,0,0,9.127,24.569Zm1.857,4.163H7.27a.179.179,0,0,1-.18-.18,2.037,2.037,0,1,1,4.074,0A.179.179,0,0,1,10.984,28.732ZM7.46,28.371h3.332a1.676,1.676,0,0,0-3.332,0Zm8.363-3.278H11.813a.18.18,0,1,1,0-.361h4.011a.18.18,0,1,1,0,.361Zm0,1.1H11.813a.18.18,0,1,1,0-.361h4.011a.18.18,0,1,1,0,.361Zm0,1.1H11.813a.18.18,0,0,1,0-.361h4.011a.18.18,0,0,1,0,.361Zm0,1.1H11.813a.18.18,0,0,1,0-.361h4.011a.18.18,0,0,1,0,.361Z" transform="translate(-5.772 -20.766)" fill="'+module.exports.hexToRgbA(fillColor)+'" stroke="'+module.exports.hexToRgbA(fillColor)+'" stroke-width="0.3"/>\n' +
                    '      <g id="Group_14070" data-name="Group 14070" transform="translate(4.33 1.5)">\n' +
                    '        <path id="Path_10938" data-name="Path 10938" d="M26.21,15.451h-2.4a.506.506,0,0,1-.506-.506v-.69a.506.506,0,0,1,.506-.506h2.4a.506.506,0,0,1,.506.506v.69A.5.5,0,0,1,26.21,15.451Zm-2.4-1.338a.145.145,0,0,0-.145.145v.69a.145.145,0,0,0,.145.145h2.4a.145.145,0,0,0,.145-.145v-.69a.145.145,0,0,0-.145-.145Z" transform="translate(-23.3 -13.75)" fill="'+module.exports.hexToRgbA(fillColor)+'" stroke="'+module.exports.hexToRgbA(fillColor)+'" stroke-width="0.3"/>\n' +
                    '      </g>\n' +
                    '      <g id="Group_14071" data-name="Group 14071" transform="translate(5.12)">\n' +
                    '        <path id="Path_10939" data-name="Path 10939" d="M29.21,7.542a.179.179,0,0,1-.18-.18V6.6a.559.559,0,1,0-1.119,0v.762a.18.18,0,1,1-.361,0V6.6a.92.92,0,1,1,1.84,0v.762A.18.18,0,0,1,29.21,7.542Z" transform="translate(-27.55 -5.68)" fill="'+module.exports.hexToRgbA(fillColor)+'" stroke="'+module.exports.hexToRgbA(fillColor)+'" stroke-width="0.3"/>\n' +
                    '      </g>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Doctor':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26853" data-name="Group 26853" transform="translate(-9312 -11948)">\n' +
                    '    <g id="doctor" transform="translate(9356.984 11988.932)">\n' +
                    '      <path id="Path_12306" data-name="Path 12306" d="M55.695,47.823c-4.232-8.041-8.464-6.771-13.12-7.195A13.047,13.047,0,0,1,43,44.861c6.771,1.693,8.464,9.734,8.464,14.389v4.232H43V59.25H47.23s0-10.58-6.348-10.58-6.348,10.157-6.348,10.58h4.232v4.232H30.3V59.25c0-4.655,1.693-13.12,8.464-14.389a14.707,14.707,0,0,0-.846-5.5,2.858,2.858,0,0,1-1.693-2.539c0-2.539,3.386-1.693,5.925-6.348,0,0,3.809-9.734,2.539-18.2h0a7.779,7.779,0,0,0-.3-2.18,10.056,10.056,0,0,0-.543-1.9v-.15C42.575,3.809,38.343,0,30.3,0S18.029,3.809,16.336,8.464h0a15.761,15.761,0,0,0-.578,2.07c-.109.9-.129.653-.268,2.162h0c-.846,8.464,2.539,18.2,2.539,18.2,2.539,4.232,5.925,3.386,5.925,6.348,0,2.116-2.116,2.963-4.655,3.386-.846.846-1.693,2.539-1.693,5.925v5.079a6.365,6.365,0,0,1,4.232,5.925c0,2.963-2.963,5.925-6.348,5.925a6.509,6.509,0,0,1-6.348-6.348,5.977,5.977,0,0,1,4.232-5.925V46.13a21.442,21.442,0,0,1,.846-5.5c-2.963.423-6.348,1.693-9.311,7.195C2.37,52.479,1.1,67.714,1.1,67.714H59.08c.423,0-.846-15.236-3.386-19.891Z" transform="translate(0)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_12307" data-name="Path 12307" d="M8.232,15.116A2.116,2.116,0,1,1,6.116,13,2.116,2.116,0,0,1,8.232,15.116Z" transform="translate(9.373 42.018)" fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'User':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26854" data-name="Group 26854" transform="translate(-9312 -12119)">\n' +
                    '    <circle id="Ellipse_266" data-name="Ellipse 266" cx="75" cy="75" r="75" transform="translate(9312 12119)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="Group_26845" data-name="Group 26845">\n' +
                    '      <g id="Group_26843" data-name="Group 26843" transform="translate(322.872 437.125)">\n' +
                    '        <g id="Group_26844" data-name="Group 26844" transform="translate(9028 11724.451)">\n' +
                    '          <path id="person_4_" data-name="person (4)" d="M19.073,26.468c-.333.016-.667.04-1.267.1C8.89,27.467,0,35.076,0,44.443v8.988H71.9V44.443c0-9.3-8.908-16.865-18.393-17.909-.122-.016-.526-.047-.93-.066-4.853,5.482-9.347,5.019-16.627,5.019S23.927,31.95,19.073,26.468Z" transform="translate(0 11.085)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '          <circle id="Ellipse_263" data-name="Ellipse 263" cx="19" cy="19" r="19" transform="translate(17.128 0.423)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '        </g>\n' +
                    '      </g>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Network':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26849" data-name="Group 26849" transform="translate(-9607 -11373)">\n' +
                    '    <circle id="Ellipse_267" data-name="Ellipse 267" cx="75" cy="75" r="75" transform="translate(9607 11373)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <path id="Subtraction_7" data-name="Subtraction 7" d="M-8660.631-11598.523h-12.716a1.5,1.5,0,0,1-1.529-1.471v-12.213a1.49,1.49,0,0,1,1.431-1.465h12.946a1.5,1.5,0,0,1,1.4,1.465v12.213A1.5,1.5,0,0,1-8660.631-11598.523Zm-29.813,0h-12.715a1.5,1.5,0,0,1-1.526-1.471v-12.213a1.491,1.491,0,0,1,1.436-1.465h12.9a1.494,1.494,0,0,1,1.438,1.465v12.213A1.5,1.5,0,0,1-8690.444-11598.523Zm-29.809,0h-12.717a1.5,1.5,0,0,1-1.525-1.471v-12.213a1.491,1.491,0,0,1,1.435-1.465h12.9a1.493,1.493,0,0,1,1.437,1.465v12.213A1.5,1.5,0,0,1-8720.253-11598.523Zm25.978-17.613h0l-5.048,0v-7.1h-24.763v7.1h-5.048v-9.527a2.48,2.48,0,0,1,2.524-2.426h27.286v-8.592h-7.946a2.015,2.015,0,0,1-2.051-1.969v-16.377a2.015,2.015,0,0,1,2.051-1.971h20.941a2.014,2.014,0,0,1,2.049,1.971v16.377a2.014,2.014,0,0,1-2.049,1.969h-7.946v8.592h27.286a2.477,2.477,0,0,1,2.521,2.426v9.525l-5.047,0v-7.1h-24.761v7.105Z" transform="translate(18379 23076.344)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Fire':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26857" data-name="Group 26857" transform="translate(-8957 -11849)">\n' +
                    '    <circle id="Ellipse_264" data-name="Ellipse 264" cx="75" cy="75" r="75" transform="translate(8957 11849)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <path id="Path_20450" data-name="Path 20450" d="M68.919,114.61c-10.275-.177-17.855-5.146-22.613-13.92-5-9.228-4.048-18.452,1.977-27.1,1.28-1.837,2.606-3.935,5.2-3.171,2.793.82,2.189,3.478,2.272,5.615.12,3.186-.106,6.408.29,9.555a7.515,7.515,0,0,0,6.571,6.959c3.591.612,6.868-.025,9.194-3.181a7.847,7.847,0,0,0,.162-9.631c-1.923-2.8-4.564-5.1-6.848-7.659-7.828-8.757-4.5-16.6,1.388-24.524,1.751-2.36,4.134-2.164,4.773.9,1.862,8.931,9.039,13.7,14.691,19.726,14.352,15.3,10.13,37.574-8.383,44.97A24.585,24.585,0,0,1,68.919,114.61Z" transform="translate(8962.914 11844.05)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Heartbeat':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26850" data-name="Group 26850" transform="translate(-9607 -11557)">\n' +
                    '    <circle id="Ellipse_268" data-name="Ellipse 268" cx="75" cy="75" r="75" transform="translate(9607 11557)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="cardiogram" transform="translate(9647 11600)">\n' +
                    '      <path id="Path_12304" data-name="Path 12304" d="M35.1,30.829C50.4,17.452,69.844,29.2,70.163,45.139A20.689,20.689,0,0,1,66.739,56.8H51.615l-2.69-4.483a2.055,2.055,0,0,0-3.5-.046l-5.676,8.919L31.48,43.726a2.057,2.057,0,0,0-3.667-.095L20.721,56.8H3.468C-9.312,36.827,15.946,14.073,35.1,30.829Z" transform="translate(0 -25.006)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_12305" data-name="Path 12305" d="M65.784,211.935l5.747-10.672,8.126,17.155a2.057,2.057,0,0,0,3.592.223l5.888-9.253,1.578,2.629a2.055,2.055,0,0,0,1.763,1h13.036c-.409.428,1.769-1.746-26.934,26.809a2.056,2.056,0,0,1-2.9,0c-28.261-28.115-26.526-26.382-26.934-26.809H63.974a2.055,2.055,0,0,0,1.81-1.081Z" transform="translate(-42.026 -177.11)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Security':
                Icon ='<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26851" data-name="Group 26851" transform="translate(-9607 -11759)">\n' +
                    '    <circle id="Ellipse_269" data-name="Ellipse 269" cx="75" cy="75" r="75" transform="translate(9607 11759)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="Group_26846" data-name="Group 26846" transform="translate(333.508 -74.384)">\n' +
                    '      <path id="Subtraction_8" data-name="Subtraction 8" d="M24.859,56.546h0l-.662-.265A39.91,39.91,0,0,1,0,19.556V7.093L24.859,0,49.718,7.093V19.556a39.91,39.91,0,0,1-24.2,36.725l-.662.265ZM24.852,6.895V49.288l.8-.431a33.322,33.322,0,0,0,17.435-29.3V12.1Z" transform="translate(9321 11883)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_20439" data-name="Path 20439" d="M256,7.093V19.556a39.924,39.924,0,0,0,24.2,36.725l.663.265V0Z" transform="translate(9065 11883)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Hospital':
                Icon ='<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26852" data-name="Group 26852" transform="translate(-9607 -11961)">\n' +
                    '    <circle id="Ellipse_270" data-name="Ellipse 270" cx="75" cy="75" r="75" transform="translate(9607 11961)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="Group_26847" data-name="Group 26847" transform="translate(484.601 311.972)">\n' +
                    '      <path id="Subtraction_5" data-name="Subtraction 5" d="M46.3,77H3.7A3.735,3.735,0,0,1,0,73.244V16.9a3.735,3.735,0,0,1,3.7-3.757H16.667V2a2,2,0,0,1,2-2H33.185a2,2,0,0,1,2,2V13.146H46.3A3.735,3.735,0,0,1,50,16.9V73.244A3.735,3.735,0,0,1,46.3,77ZM17.267,50.707a.6.6,0,0,0-.6.6V70.765a.6.6,0,0,0,.6.6H30.881a.6.6,0,0,0,.6-.6V51.307a.6.6,0,0,0-.6-.6ZM28.377,33.8a.6.6,0,0,0-.6.6V42.6a.6.6,0,0,0,.6.6H40.14a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6Zm-20.37,0a.6.6,0,0,0-.6.6V42.6a.6.6,0,0,0,.6.6H19.77a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6Zm20.37-13.146a.6.6,0,0,0-.6.6v8.19a.6.6,0,0,0,.6.6H40.14a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6Zm-20.37,0a.6.6,0,0,0-.6.6v8.19a.6.6,0,0,0,.6.6H19.77a.6.6,0,0,0,.6-.6v-8.19a.6.6,0,0,0-.6-.6ZM21.533,6.4a1.173,1.173,0,0,0-1.163,1.18V8.76a1.173,1.173,0,0,0,1.163,1.18h2.676v2.713a1.173,1.173,0,0,0,1.164,1.18h1.163a1.173,1.173,0,0,0,1.164-1.18V9.94h2.675a1.173,1.173,0,0,0,1.164-1.18V7.58A1.173,1.173,0,0,0,30.374,6.4H27.7V3.686a1.173,1.173,0,0,0-1.164-1.179H25.373a1.173,1.173,0,0,0-1.164,1.179V6.4Z" transform="translate(9172.399 11686.028)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Rectangle_7797" data-name="Rectangle 7797" d="M1,0H60a1,1,0,0,1,1,1V4a0,0,0,0,1,0,0H0A0,0,0,0,1,0,4V1A1,1,0,0,1,1,0Z" transform="translate(9167.399 11759.028)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'Operator':
                Icon = '<svg id="recent_roles_icons_svg" xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150">\n' +
                    '  <g id="Group_26858" data-name="Group 26858" transform="translate(-9116 -11849)">\n' +
                    '    <circle id="Ellipse_264" data-name="Ellipse 264" cx="75" cy="75" r="75" transform="translate(9116 11849)" fill="'+ module.exports.hexToRgbA(onCallImage) +'"/>\n' +
                    '    <g id="call-center_Svg" data-name="call-center Svg" transform="translate(9058.147 11838.974)">\n' +
                    '      <path id="Subtraction_10" data-name="Subtraction 10" d="M62.066,22.4H.071a5.923,5.923,0,0,1-.061-1.28A22.167,22.167,0,0,1,17.948.054,1.8,1.8,0,0,1,18.3.016a1.2,1.2,0,0,1,.76.27A18.868,18.868,0,0,0,30.291,3.87a27.757,27.757,0,0,0,5.093-.316A18.724,18.724,0,0,0,43.075.287,1.25,1.25,0,0,1,43.864,0a1.643,1.643,0,0,1,.322.034,21.907,21.907,0,0,1,13.453,8.4,21.68,21.68,0,0,1,4.484,13.14,4.633,4.633,0,0,1-.058.816Z" transform="translate(101.853 97.488)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_20448" data-name="Path 20448" d="M189.076,137.441a13.047,13.047,0,0,1-6.894-.922,17.627,17.627,0,0,1-7.565-6.2,20.3,20.3,0,0,1-3.646-8.613,16.357,16.357,0,0,1,3.185-13.181,16.617,16.617,0,0,1,29.59,7.565,17.791,17.791,0,0,1-1.278,9.724c-.482,1.132-1.111,2.2-1.677,3.29a.66.66,0,0,1-.356.272c-.9.21-1.823.4-2.724.566a.655.655,0,0,1-.4-.084,4.679,4.679,0,0,0-2.871-.9h-3.206a4.355,4.355,0,0,0-2.766.964,4.515,4.515,0,0,0,.147,7.167A5.149,5.149,0,0,0,189.076,137.441Z" transform="translate(-54.418 -40.296)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '      <path id="Path_20449" data-name="Path 20449" d="M167.212,90.5a17.245,17.245,0,0,1-3.583,2.012,24.651,24.651,0,0,1-6.915,1.739h-.063a1.369,1.369,0,0,0-1.236.587,2.144,2.144,0,0,1-1.823.838H150.3a2.483,2.483,0,0,1-.021-4.967c1.09-.021,2.2,0,3.29,0a2.523,2.523,0,0,1,1.991.943.571.571,0,0,0,.335.168,20.427,20.427,0,0,0,9.409-3.08.354.354,0,0,0,.189-.482A4.252,4.252,0,0,1,165.305,87c-.021-2.745-.021-5.511,0-8.257a4.023,4.023,0,0,1,2.1-3.625.311.311,0,0,0,.189-.356,20.888,20.888,0,0,0-2.6-8.885,21.265,21.265,0,0,0-31.958-6.329,20.587,20.587,0,0,0-3.9,4.086,26.417,26.417,0,0,0-1.572,2.515,20.923,20.923,0,0,0-2.452,8.592.285.285,0,0,0,.168.335,4.037,4.037,0,0,1,2.117,3.688v8.11a4.183,4.183,0,0,1-2.724,4,4.35,4.35,0,0,1-4.82-1.257,3.925,3.925,0,0,1-.943-2.452c-.021-2.892-.042-5.8,0-8.7a3.873,3.873,0,0,1,2.117-3.395.431.431,0,0,0,.251-.4,23.147,23.147,0,0,1,.65-4.485,24.909,24.909,0,0,1,9.263-14.082,24.249,24.249,0,0,1,11.945-4.883,25.157,25.157,0,0,1,27.054,17.079,23.78,23.78,0,0,1,1.216,6.412.341.341,0,0,0,.23.356,4.083,4.083,0,0,1,2.159,3.709c0,2.682-.021,5.365,0,8.047a4.249,4.249,0,0,1-6.413,3.751C167.338,90.586,167.3,90.544,167.212,90.5Z" transform="translate(-13.463)"  fill="'+module.exports.hexToRgbA(fillColor)+'"/>\n' +
                    '    </g>\n' +
                    '  </g>\n' +
                    '</svg>';
                break;
            case 'None':
                Icon = "";
                break;
            default:
                Icon = "";
        }

          return Icon;
    },

    getConnectCanLogin: function () {
        let canLogin = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: module.exports.randomString(16, 'a#'),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            status: "check_connect_can_login"
        });
        if (stropheConnection.Connection().connected) 
            stropheConnection.Connection().sendIQ(canLogin, module.exports.connectCanLoginCallback);
    },
    connectCanLoginCallback: function (connectCanLoginIq) {
        try {
            $(connectCanLoginIq).find("query").each(function (index) {
                let loginAllowed = $(this).attr("connect_can_login");
                if (loginAllowed == "0") {
                    $(".main-screen-bg").css("display", "none");
                    $(".login-container").css("display", "flex");
                    $("#keycloak-sol-button").css("display", "none")
                    let maillBody = language.locali().mailBody.replace("\n", "%0D%0A").replace("\n\n", "%0D%0A%0D%0A");
                    $("#mail_content").html(' <p class="note">'+language.locali().messageContent+'</p>' +
                    '<div style="max-width: 37%;margin-left: 178px;" class="mail_div"><a style="float: left;"class="button_mail" href="mailto:'+language.locali().mailTo+'?subject='+language.locali().mailSubject+'&body='+maillBody+'">Send</a> <a style="float: right;" href="javascript:void(0)" id="reset_login">Login</a></div>');
                }
            });
        } catch (err) {
            console.log("block user list callback", err);
            console.log("block user list callback iq", blocklistiq);
        }
        return true;
    },

    convertUtcToLocal: function (ConvertDate) {
        let dateString = new Date(ConvertDate+' UTC');

        let date_ob = dateString
        // year as 4 digits (YYYY)
        let year = date_ob.getFullYear();

        // month as 2 digits (MM)
        let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

        // date as 2 digits (DD)
        let date = ("0" + date_ob.getDate()).slice(-2);

        // hours as 2 digits (hh)
        let hours = ("0" + date_ob.getHours()).slice(-2);

        // minutes as 2 digits (mm)
        let minutes = ("0" + date_ob.getMinutes()).slice(-2);

        // seconds as 2 digits (ss)
        let seconds = ("0" + date_ob.getSeconds()).slice(-2);
        
        // Convert Timestamp to (YYYY-MM-DD H:M:S) Format
        dateString = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;

        return dateString;
    },
    reconnectionPopupShow: function () {
        $('#re-connection').css('visibility', 'visible');
        $('#re-connection').css('opacity', '1');
    },
    /** PDF file Download function **/
    FileDownload: function(url, filename) {
        fetch(url)
        .then(function(t) {
            return t.blob().then((b)=>{
                let a = document.createElement("a");
                a.href = URL.createObjectURL(b);
                a.setAttribute("download", filename);
                a.click();
            }
            );
        });
    },
    /** Update Roaster Function**/
    updateRosterDetails: function(nodeJid,toUserName){
        let loggedUserId = loginUserInfo[0][0];
        let loginUserName = JSON.parse(localStorage.myInfo)[loggedUserId][1]
        let saveRoster = stropheConnection.StropheJs().$iq({
            type: 'set',
            id: module.exports.getId(),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_profile',
            status: 'update_roster',
            contact: nodeJid,
            contact_name: toUserName,
            nick_name: loginUserName
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(saveRoster);
        }
    },
    imageTokenRegenerate: function(imageUrl,element,key,tabelName,type){
        $.ajax({
            url: imageUrl,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': storage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                    let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
                    let username = loginUserInfo[0][0];
                    userSession.setSession(username).then(response => {
                      let userToken = storage.getuserToken();
                      imageUrl =mediaUrl+ profileImage+"?mf="+userToken;
                      indexDb.blobImageConversion(imageUrl,element,key,tabelName);

                    })
                },
                500: function (response) {
                    console.log('Internal Server Error');
                },
                200: function (response) {
                  console.log("SUCCESS")
                  indexDb.blobImageConversion(imageUrl,element,key,tabelName);
                }
            },
            success: function (response) {
              console.log("SUCCESS")
            }
          });
    },
    cryptoRandomGenerate: function(){
       // Using crypto.getRandomValues() for better randomness
        let cryptoRandomValues = new Uint32Array(1);
        crypto.getRandomValues(cryptoRandomValues);
        let randomValue = (cryptoRandomValues[0] / (0xffffffff + 1));

        return randomValue;
    },
    getHexRegexPattern: function() {
        return /^#[0-9A-F]{6,8}$/i;
    },
    getImageDisplayText: function(name){
        let concatedLetter;
        if(name != "") {
          let splitedArr = name.split(' ');
          let splitedNameArr = splitedArr.filter(function(v){return v!==''});
          let firstNameLetter,secondNameLetter;
          if(splitedNameArr.length == 1){
              firstNameLetter = splitedNameArr[0][0];
              secondNameLetter = splitedNameArr[0][1];
          }else {
              firstNameLetter = splitedNameArr[0][0];
              secondNameLetter = splitedNameArr[1][0];
      
          }
          concatedLetter = (firstNameLetter+secondNameLetter).toUpperCase()
        }
      
        return concatedLetter;
    },
    commonNotificationMsgAlert: function(notifyName,messagebody,notifyJid){
        let recentdesign = require('./recentdesign.js');

        Notification.requestPermission().then(function(permission) {
            if (permission === 'granted') {
                // Permission is granted, create the push notification
                Push.create(notifyName, {
                    body: messagebody,
                    timeout: 3000,
                    onClick: function () {
                        window.focus();
                        recentdesign.recentClickAction(notifyJid);
                        this.close();
                    }
                });
            } else if (permission === 'denied') {
                // Permission is denied, show a message to the user
                console.log('Push notification permission is denied. You may not receive notifications.');
        
                // You can also provide a UI element or a button to prompt the user to grant permission
                // Example: showPermissionPromptButton();
            } else {
                // Permission is in the default state (neither granted nor denied)
                console.log('Push notification permission is not granted yet.');
            }
            module.exports.commonHeaderTitleUpdate();
           
        }).catch(function(error) {
            console.log('Error requesting push notification permission:', error);
        });

    },
    
    commonHeaderTitleUpdate: function(){
        let notifiElemntCount = Array.from(document.querySelectorAll(".notify"))
                                .filter(el => parseInt(el.textContent.trim(), 10) > 0).length;

        if(notifiElemntCount == 0){
        document.title = "Ikonix Connect";
        }else {
        document.title = "(" + notifiElemntCount + ") Ikonix Connect";
        }
    },

    /** Participant Div Calculation and Update**/
    getAddParticipantStaticDivHeight: function(elementId,is_header_tab){
        if(elementId != '#undefined'){
            let participantHeaderHeight = $('#teamParticipantMainDiv .newMessage-heading').outerHeight(true);
            let participantUlListEl = $('#teamParticipantMainDiv .group-list-sec:visible');
            let participantUlListHeight;
    
            if(typeof participantUlListEl.outerHeight(true) == 'undefined'){
                participantUlListHeight = 30;
            }else {
                let participantUlListScrollCheck = participantUlListEl[0].scrollHeight > participantUlListEl[0].clientHeight;
    
                participantUlListHeight = participantUlListEl.outerHeight(true);
    
                if(participantUlListScrollCheck){
                    participantUlListHeight = participantUlListHeight-5;
                }
            }
            let participantSearchHeight = $('#teamParticipantMainDiv .grpcreate-search:visible').outerHeight(true);
            let Height = participantHeaderHeight + participantUlListHeight + participantSearchHeight;
            
            return Height;
        }
        
      },
      errorMsgHandling: function(jqXHR, exception){
        let errMsg = '';
        if (jqXHR.status === 0) {
            errMsg = 'Not connect.\n Verify Network.';
            module.exports.reconnectionPopupShow();

        } else if (jqXHR.status == 404) {
            errMsg = 'Requested page not found. [404]';
        } else if (jqXHR.status == 500) {
            errMsg = 'Internal Server Error [500].';
        } else if (exception === 'parsererror') {
            errMsg = 'Requested JSON parse failed.';
        } else if (exception === 'timeout') {
            errMsg = 'Time out error.';
        } else if (exception === 'abort') {
            errMsg = 'Ajax request aborted.';
        } else {
            errMsg = 'Uncaught Error.\n' + jqXHR.responseText;
        }
        console.log(errMsg);
      },
      blockUserDesignAdd: function(displayname){
        $(".block-con").hide();
        $(".unblock-con").show();
        $("#comment").empty();
        $("#send-icon").css("display", "none");
        $('.heading-attach').hide();
        $(".row.reply").css("display", "none");
        $(".blocked-person").css("display", "block");
        $(".blocked-person").text("Can't send a message to blocked contact " + minEmoji(displayname));
        $("#replyemoji").hide();
        $(".heading-online").html("");
      },

      msgCloseEventTrigger: function(tojid,blockUserInfo){
        if (tojid != null &&  (blockUserInfo != null && typeof blockUserInfo[stropheConnection.Strophe().getNodeFromJid(tojid)] != "undefined") ) {
          $('.row.reply').hide();
          $(".blocked-person").css("display", "block");
        } else {
          $('.row.reply').css('display', 'flex');
          $(".blocked-person").css("display", "none");
        }
      },

      unRegisterUserCmtBoxDesign: function(userInfo,nodeJid){
        let unregisteredUser = userInfo[nodeJid] ? userInfo[nodeJid][16] : '';
        if (unregisteredUser != 1) {
            $(".unblock-con").hide();
            $('.block-con').show()
            $('.heading-attach').show()
            $(".row.reply").css("display", "flex");
            $('#comment').attr("data-text", "Start typing...");
        }else {
            $(".row.reply").css("display", "none");

            $(".blocked-person").css("display", "block");
            $('.blocked-person').text("You cannot send messages to this chat.");
            $('.block-con').hide();
        }
      },
      imgElementErrorCheck: function(imgEl){
        imgEl.onerror = function(){
            let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('class','avatar-svg');
            svg.setAttribute('viewBox','0 0 100 100');

            svg.setAttribute('xmlns','http://www.w3.org/2000/svg');
            svg.setAttribute('xmlns:xlink','http://www.w3.org/1999/xlink');
            svg.setAttribute('style','transform: scale(1.25);');

            let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            circle.setAttribute('fill','#CCC');
            circle.setAttribute('cx','50');
            circle.setAttribute('cy','50');
            circle.setAttribute('r','50');

            let text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            text.setAttribute('dominant-baseline', 'central');
            text.setAttribute('fill', 'rgba(255,255,255,1)');
            text.setAttribute('font-size', '30pt');
            text.setAttribute('text-anchor', 'middle');
            text.setAttribute('x', '50');
            text.setAttribute('y', '50');
            text.setAttribute('style', 'font-weight:700');

            text.textContent = this.getAttribute('data-text');

            svg.appendChild(circle);
            svg.appendChild(text); 
            this.replaceWith(svg);
        }
      },

    /* Assume obj is your object and value is the value you want to check for */
    isValueInObject: function(obj, value) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] === value) {
                return true;
            }
        }
        return false;
      },
      /** Append Recent Elements in forward contact box **/
      appendRecentElements : function(){
        $("#forward-msg .recentchatcontact").children().remove();
        $(".recentcontent").each(function () {
            let nodeJid = $(this).attr('id');
            let svgImg = $(this).find('.color-code-recent');
            let image = $(this).find('img');
            let name = $(this).find('.name-and-status-div span').html();
            let msgContent = $(this).find('.name-status.text-italic');
            let fwdImage;
            if(image.length >0){
                fwdImage = image;
            }else {
                if(svgImg.length > 0){

                    fwdImage = svgImg;
                }else {
                    fwdImage = $(this).find('svg')
                }
            }

            let contactDiv = '<div class="row sideBar-body contactcontent recentGroupContactDiv" id="forwardcontact-' + nodeJid + '"><div class="select-cnt-blk"><input type="checkbox" class="select-message3" name="' + name + '" value="' + nodeJid + '" id="' + image + '"><label></label></div><div class="col-sm-3 col-xs-3 sideBar-avatar">';

            let imageDiv = '<div class="avatar-icon recentGroupImageDiv"> </div> </div>';

            let nameDiv = '<div class="col-sm-9 col-xs-9 sideBar-main recentGroupNameDiv"><div class="row"><div class="col-sm-12 col-xs-12  sideBar-name"><span class="name-meta">' + minEmoji(name) + '</span><span class="name-status fwdMsgSpan">' + msgContent + "</span></div></div></div></div>";

            $("#forward-msg .recentchatcontact").append(contactDiv + imageDiv + nameDiv);

            let fwdImageClone = fwdImage.clone();
            let msgContentClone = msgContent.clone();


            $("#forward-msg .recentchatcontact #forwardcontact-"+ nodeJid + " .recentGroupImageDiv").html(fwdImageClone)
            $("#forward-msg .recentchatcontact #forwardcontact-"+ nodeJid + " .fwdMsgSpan").html(msgContentClone.first())

            $("#forward-msg .recentchatcontact #forwardcontact-"+ nodeJid + " .rollicon").remove();

        });

        $("#forward-msg #recent-contact").scrollTop(0)

      },
      /** Check Device Operating system Type **/

      getDeviceOsType: function() {
        const userAgent = navigator.userAgent;
        let osType;
        if (/Windows/.test(userAgent)) {
            osType = "Windows";
        } else if (/Android/.test(userAgent)) {
            osType = "Android";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            osType = "iOS";
        } else if (/Macintosh/.test(userAgent)) {
            osType = "macOS";
        } else if (/Linux/.test(userAgent)) {
            osType = "Linux";
        } else {
            osType = "Unknown";
        }
      
        return osType;
      },
      /** Static Div Height Calculation In Contact,Team & Broadcast Page **/
      StaticDivHeightCalculation: function(osType,participantStaticDivHeight){
        if(osType == "Windows"){
          participantStaticDivHeight = participantStaticDivHeight-4;
        }
      
        return participantStaticDivHeight;
    },
    selectRecentFwdUser: function(id, name, image) {
        let selecteduserInfo = webEncrypt.getFromLocalStorageAndDecrypt('selecteduserInfo') || [];
        const userExists = selecteduserInfo.some(user => user[0] === id);

        if (!userExists) {
            selecteduserInfo.push([id, name, image]);
            webEncrypt.encryptAndStoreInLocalStorage('selecteduserInfo', selecteduserInfo);
            
        }
    },

    unselectRecentFwdUser: function(id) {
        let selecteduserInfo = webEncrypt.getFromLocalStorageAndDecrypt('selecteduserInfo') || [];
        selecteduserInfo = selecteduserInfo.filter(user => user[0] !== id);

        webEncrypt.encryptAndStoreInLocalStorage('selecteduserInfo', selecteduserInfo);

    },

    getSpecialGroupForegroundColor: function(onCallForegroundColor){
        let fillColor = onCallForegroundColor?onCallForegroundColor:"#fff";
        return fillColor;
    },
    msgBoxDivHeight: function(){
        let divJid,height;
      
        let toJid = webEncrypt.getFromLocalStorageAndDecrypt('toJID')
      
        divJid = stropheConnection.Strophe().getNodeFromJid(toJid);

        if ($("#comment").height() >= 20) {
         
          $("[id='conversation"+divJid+"']").css({ height: "calc(100% - 135px)" });
          let MessageHeight = $("[id='conversation"+divJid+"']").height() - $("#comment").height() + 30;
          $("[id='conversation"+divJid+"']").height(MessageHeight);
          height = 0;
          $("[id='conversation"+divJid+"']").find('.row').each(function (i, value) {
            height += parseInt($(this).height());
          });
          $("#messageemoji").find('.emojiPicker').css({ top: -349 - $("#comment").height() + 30 });
          $("[id='conversation"+divJid+"']").scrollTop(height);
          $(".reply-content").css({ bottom: $("#comment").height() + 65 });


        } else {
          $("[id='conversation"+divJid+"']").css({ height: "calc(100% - 135px)" });
          $(".reply-content").css({ bottom: "75px" });

         
        }

        if($(".reply-content:visible").length > 0){
            let cmtBoxHeight = $(".reply-box").outerHeight();
            let headerHeight = $("#con-head").outerHeight();
            let replyCtHeight = $(".reply-content").outerHeight();
            let totalHeight = cmtBoxHeight+headerHeight+replyCtHeight;

            $("[id='conversation"+divJid+"']").css({ height: "calc(100% - "+  totalHeight +"px)" });

        }
    },
    moveConvoMsgInputCursorEnd: function(){
        let editableDiv = document.getElementById("comment");
        console.log(editableDiv.textContent.length)
        if (editableDiv) {
            let range = document.createRange();
            let selection = window.getSelection();
    
            range.selectNodeContents(editableDiv); // Select the text inside
            range.collapse(false); // Collapse to the end (move cursor to end)
    
            selection.removeAllRanges(); // Remove any existing selections
            selection.addRange(range); // Set the new range
        }
    },
    cmtIconTypeCheck: function() {
        let editableDiv = document.getElementById("comment");
        if (editableDiv.textContent.length > 0) {
            $("#microphone").hide();
            $("#send-icon").show();
        }else {
            $("#microphone").show();
            $("#send-icon").hide();

        }
    }
      

};

